'use strict';
const React = require('react');
export const AvailabilityContext = React.createContext();
const toastr = require('toastr');

const HeaderLayout = require('../layouts/header').HeaderLayoutComponent;
const FooterLayout = require('../layouts/footer').FooterLayoutComponent;
const ReactRedux = require('react-redux');

const BaseComponent = require('../shared/base');
const cartActions = require('../../redux/cartActions');
const actionTypes = require('../../redux/actionTypes');
const CommonModule = require('../../public/js/common');
const { OrderSummary,  customMapDispatchToProps } = require('./order-summary');
const CustomMethods = require('../features/pricing_type/' + process.env.PRICING_TYPE + '/cart/custom');

const AddressInformation = require('./address-information');
const PaymentInformation = require('./payment-information');
const StepperFlow = require('./cart-stepper-flow');
const StepperControl = require('../../public/js/bepensa/stepper-control');
const SuggestedCarousel = require('../custom/cart/suggested-carousel');
let stepperHandler = null;
const client = require('../../../sdk/client');
const { use } = require('passport');

let context = null;
if (typeof window !== 'undefined'){
    require('../../public/js/bepensa/JQBlockUI');
}

class CartPageComponent extends CustomMethods {
    constructor(props) {
        super(props);
        console.log('cart>main.jsx');
        //														//obtener brach y depot usado cookies y servicios
		this.selectedAddressLider = '';
		this.selectedAddressBranch = '';
        this.SelectedAddressCookie = '';
        this.os_branchId = -1;
		this.os_depotId = -1;

        this.state = {
            arrAddresses : [],
            arrShipmentMethods: [],
            cartObject : this.setCartStateFromProperties(props),
            intTotalQuantities: this.intGetTotalQuantity(props),
            getTotalWeight: this.getTotalWeight(props),
            numTotalOrder: this.numGetOrderTotal(props, 0),
            numItemPriceTotal: this.numGetOrderTotal(props, 1),
            numItemCoreTotal: this.numGetOrderTotal(props, 2),
            numBaseIVA: 0.16,
            currentExchange: -1.0, //Default value in order to check if Exchange Currency has changed by a callback.
            currentCurrency: "MXN",
            isEmpty: (props.cartPageModel.cartList && props.cartPageModel.cartList.length !== 0) ? 'hide' : '',
            isNotEmpty: (props.cartPageModel.cartList && props.cartPageModel.cartList.length > 0) ? '' : 'hide',
            merchantId: process.env.MERCHANT_ID,
            methodPaymentSelected: 'Línea de crédito',
            strCookieAddressId: "",
            arrAlmacenes: [],
            arrConfiguracionUsuario: [],
            arrAvailabilityParts: [],
            arrSucursales: [],
            objConfigurationResponse: [],
            objAlmacenesResponse: [],
            strSelectedPartCode: "",
            hideBackButton: true,
            currentStep: 1,
            boolShowNextStepButton: true,
			boolShowContinueButton: true,
			boolShowPayButton: false,
            boolIsVisibleCurrencyHandler: false,
            boolSalePriceWasLoaded: false,
            changeCurrencyHandler: {currencyObject:undefined},
            boolOccurLocationNotAvailable: false,
            boolHideShippingDiv: false,
            totalAvailabilityParts: Array(50).fill(0),
            userIsB2C: false,
            lastPartNumber: null,
            lastItemDetail: null,
            arrAvailabilitiesforItem: [],
            cuponDiscount: 0,
            cuponUseEnabled: 0,
            shipmentTotalValue: 0,
            shippingDataCalculation: null,
            shippingRates: null,
            cuponTypeDiscount: "percentage",
            shippingAddress: null
        }
        this.packageIdAlmacenes = process.env.ADMINISTRACION_ALMACENES;
        this.packageIdTrazabilidad = process.env.TRAZABILIDAD;
        this.hasUserConfig = undefined;
        this.extendAvailability = undefined;
        this.boolAvailabilityCheckDisabled = false;
        this.componenCartDidUpdate = false;
        this.totalOrderCalculated = 0.0;
        this.totalItemPriceCalculated = 0.0;
        this.totalItemCorePriceCalculated = 0.0;
        this.boolAvailabilityPromiseFailed = false;
        this.boolConfigAvailabilityPromiseFailed = false;
        this.boolBranchesPromiseFailed = false;
        this.intRetries = 0;
        this.intLimitRetries = 5
        this.couponfeature = this.couponfeature.bind(this);
        this.handleAddressChange = this.handleAddressChange.bind(this);
        this.arrOfParts = [];
    }

    //-----------------------------------------------------------------------------------------------------------------
    setUserDefaultAddress(){
		var self = this;
        if (typeof this.props.user != 'undefined') {
            client.Addresses.getUserAddresses(this.props.user.ID,
				function(err, addresses) {
					if (err) {
						console.error("Error getting user addresses:", err);
						return;
					}

					if (addresses != null && addresses.Records != null && addresses.Records.length > 0)
				    {
                        self.setState({"arrAddresses" : addresses.Records});
                        self.renderAddressesOptions();
                        self.subSetOptionAddressSelected();
							
                        // We need to check that the default address fulfill that it is a shipping address.
						var billingAddress = null;
						addresses.Records.forEach(address => {
							//									// Storing by default the first shipping address found.
							if(billingAddress == null && address.Pickup){
								billingAddress = address;
							}
						});

						if (billingAddress != null)
						{
							self.subGetBillingAddress(billingAddress.ID);
							/* LOGS INICIO */
							var promiseCreateTableLog = new Promise((resolve, reject) => {

									var optionsLog = {
										pluginId: process.env.NOTIFICACIONES,
										tableName: 'Logs',
										request: {
											"mensaje": "Order-summary addressID: " + billingAddress.ID
										}
									};

									client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
										resolve(result);
									});
									/* LOGS FIN */
								});

								promiseCreateTableLog.then(ctCreate => {

								}, error => {
									console.log(error);
								});
							}
							else {
								/* LOGS INICIO */
								var promiseCreateTableLog = new Promise((resolve, reject) => {
									var optionsLog = {
										pluginId: process.env.NOTIFICACIONES,
										tableName: 'Logs',
										request: {
											"mensaje": "Order-summary - no hay direcciones del usuario que sean de envio"
										}
									};

									client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
										resolve(result);
									});
									/* LOGS FIN */
								});

								promiseCreateTableLog.then(ctCreate => {

								}, error => {
									console.log(error);
								});
								console.log("Order-summary - no hay direcciones del usuario que sean de envio");
							}
						}
						else {
							/* LOGS INICIO */
							var promiseCreateTableLog = new Promise((resolve, reject) => {
								var optionsLog = {
									pluginId: process.env.NOTIFICACIONES,
									tableName: 'Logs',
									request: {
										"mensaje": "Order-summary - no hay direcciones del usuario"
									}
								};

								client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
									resolve(result);
								});

							});

							promiseCreateTableLog.then(ctCreate => {

							}, error => {
								console.log(error);
							});
							/* LOGS FIN */
							console.log("Order-summary - no hay direcciones del usuario");
						}
					} //end function
				);
        }
        else {
			/* LOGS INICIO */
			var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
						"mensaje": "Order-summay - user ID is not defined in the props"
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});

			});

			promiseCreateTableLog.then(ctCreate => {

			}, error => {
				console.log(error);
			});
            /* LOGS FIN */
           console.log("Order-summay - user ID is not defined in the props");
        }
    }

	//-----------------------------------------------------------------------------------------------------------------
	subGetBillingAddress(addressId_I){
        var self = this;
        if (
            addressId_I
            )
        {
            var userId = this.props.user.ID != null ? this.props.user.ID : "";

            //Prepare promise for warehouses collection
			const promiseSucursales = new Promise((resolve, reject) => {
				const options = {
					pluginId: process.env.ADMINISTRACION_ALMACENES,
					tableName: "Almacenes",
					query: [
						{
							Name: 'IsActive',
							Operator: "eq",
							Value: "true"
						}
					]
				};

				client.CustomTables.searchCustomTable(options, function (err, result) {
					if (err) {
						reject(err);
					} else {
						resolve(result);
					}
				});
			});

            //Prepare promise for warehouses coonfiguration
            const promiseUserConfiguration = new Promise((resolve, reject) => {
                const options = {
                    pluginId: process.env.ADMINISTRACION_ALMACENES,
                    tableName: "ConfiguracionUsuario",
                    query: [
                        {
                            Name: "UserId",
                            Operator: "equal",
                            Value: userId
                        },
                        {
                            Name: "AddressId",
                            Operator: "equal",
                            Value: addressId_I
                        }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function (err, result) {
					if (err) {
						reject(err);
					} else {
						resolve(result);
					}
                });
            });

            Promise.all([promiseSucursales, promiseUserConfiguration]).then(response => {
                let strBranchId = null;
                let strDepot = null;
				//                                                       //Check if both promises have data
                if (response[0].Records.length > 0 && response[1].Records.length > 0)
                {
                    //                                      //To easy code.
                    let arrAlmacenes = response[0].Records;
                    let configObj = response[1].Records[0];
                    for (let intIndex = 0; intIndex < arrAlmacenes.length; intIndex++) {
                        const almacen = arrAlmacenes[intIndex];
                        if (
                            almacen.Nombre == configObj.AlmacenFacturacion
                            )
                        {
							/* LOGS INICIO */
							var promiseCreateTableLog = new Promise((resolve, reject) => {
								var optionsLog = {
									pluginId: process.env.NOTIFICACIONES,
									tableName: 'Logs',
									request: {
										"mensaje": "Order-summary almacen: " + almacen.Nombre + " strDepot: " + strDepot + " strBranchId: " + strBranchId
									}
								};

								client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
									resolve(result);
								});

							});

							promiseCreateTableLog.then(ctCreate => {

							}, error => {
								console.log(error);
							});
							/* LOGS FIN */

                            strDepot = almacen.LiderId;
                            strBranchId = almacen.BrachId;
                            break;
                        }
                    }
					if(strBranchId!=null && strDepot!=null) {
						//
						this.os_branchId = strBranchId;
						this.os_depotId = strDepot;
                        self.getOccurAddressesServices(strBranchId, strDepot);
						// console.log("Order Summary - subGetBillingAddress - Se encontró la sucursal y el lider os_branchId=", this.os_branchId, "  os_depotId=" ,this.os_depotId);
					} else {
						// console.log("Order Summary - subGetBillingAddress - No se encontró la sucursal o el lider");
						/* LOGS INICIO */
						var promiseCreateTableLog = new Promise((resolve, reject) => {
							var optionsLog = {
								pluginId: process.env.NOTIFICACIONES,
								tableName: 'Logs',
								request: {
									"mensaje": "Order Summary - subGetBillingAddress - No se encontró la sucursal o el lider"
								}
							};

							client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
								resolve(result);
							});
						});

							promiseCreateTableLog.then(ctCreate => {

							}, error => {
								console.log(error);
							});
						/* LOGS FIN */
					}
                } else {
					// console.log("Order Summary - subGetBillingAddress - No hay datos en las promesas ");
					/* LOGS INICIO */
					var promiseCreateTableLog = new Promise((resolve, reject) => {
					var optionsLog = {
					pluginId: process.env.NOTIFICACIONES,
					tableName: 'Logs',
					request: {
							"mensaje": "Order Summary - subGetBillingAddress - No hay datos en las promesas "
						}
					};

					client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
						resolve(result);
					});
					});

							promiseCreateTableLog.then(ctCreate => {

							}, error => {
								console.log(error);
							});
					/* LOGS FIN */
				}
            }).catch(error => {
				console.log("Order Summary - Failing bringing subGetBillingAddress", error);

				/* LOGS INICIO */
				var promiseCreateTableLog = new Promise((resolve, reject) => {
				var optionsLog = {
				pluginId: process.env.NOTIFICACIONES,
				tableName: 'Logs',
				request: {
						"mensaje": "Order Summary - Failing bringing subGetBillingAddress " + error
					}
				};

				client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
					resolve(result);
				});
				});

							promiseCreateTableLog.then(ctCreate => {

							}, error => {
								console.log(error);
							});
				/* LOGS FIN */
			});
        }
    }
	//-----------------------------------------------------------------------------------------------------------------

    setCartStateFromProperties(props){
        let cartObject = [];
        if (props.cartPageModel.cartList && props.cartPageModel.cartList.length > 0) {
            props.cartPageModel.cartList.forEach(function(cartItem, parentIndex){
                let originalPrice = cartItem.ItemDetail.Price;
                let originalCurrency = null;
                let originalCorePrice = "0.00";
                let cfCorePrice = cartItem.ItemDetail.CustomFields.findIndex(cf => cf.Name == "Precio Core");
                if (
                    cfCorePrice >= 0
                    )
                {
                    if (
                        cartItem.ItemDetail.CustomFields[cfCorePrice].Values[0] != ""
                        )
                    {
                        originalCorePrice = cartItem.ItemDetail.CustomFields[cfCorePrice].Values[0];
                    }
                }

                let cfOriginalCurrency = cartItem.ItemDetail.CustomFields.findIndex(cf => cf.Name == "Currency");
                if(cfOriginalCurrency >= 0){
                    originalCurrency = cartItem.ItemDetail.CustomFields[cfOriginalCurrency].Values[0];
                }
                var cartItemState = {
                    CartId: cartItem.ID,
                    CartQty: cartItem.Quantity,
                    ItemDetail: cartItem.ItemDetail,
                    OriginalPrice : originalPrice,
                    OriginalCurrency : originalCurrency,
                    OriginalCorePrice : originalCorePrice
                };

                cartObject.push(cartItemState);
            });
        }

        return cartObject;
    }

    numGetOrderTotal(
        props_I = null,
        // intCalculationType values: 0 = itemPrice + coreTotal, 1 = itemPrice only, 2 = coreTotal only
        intCalculationType_I = 0
    )
    {
        var numTotalPrice = 0.0;
        var self = this;
        if(props_I != null){
            if (props_I.cartPageModel.cartList && props_I.cartPageModel.cartList.length > 0) {
                props_I.cartPageModel.cartList.forEach(function(cartItem, parentIndex){
                    var corePrice = 0.0;
                    var strCurrencyCode = "";
                    var itemPriceDefault = cartItem.ItemDetail.Price;
                    if(cartItem.ItemDetail.CustomFields != null){
                        var corePriceCF = cartItem.ItemDetail.CustomFields.find(cf => cf.Name == "Precio Core");
                        if(corePriceCF != null){
                            if(corePriceCF.Values[0].length > 0){
                                corePrice = parseFloat(corePriceCF.Values[0]);
                            }
                        }
                        var currencyCodeCf = cartItem.ItemDetail.CustomFields.find(x => x.Name == "Currency");
                        if (currencyCodeCf != undefined || currencyCodeCf != null) {
                            if(currencyCodeCf.Values[0].length > 0){
                                strCurrencyCode = currencyCodeCf.Values[0];
                            }
                        }
                    }
                    //All prices in MXN at first
                    if (
                        strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                        self.state.currentCurrency == "MXN" && (cartItem.ItemDetail.boolPriceChanged == undefined || cartItem.ItemDetail.boolPriceChanged == falese)
                        )
                    {
                        itemPriceDefault = itemPriceDefault * parseFloat(self.state.currentExchange);
                    }

                    if (
                        strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                        self.state.currentCurrency == "MXN"
                        )
                    {
                        corePrice = corePrice * parseFloat(self.state.currentExchange);
                    }

                    switch (intCalculationType_I) {
                        case 0:
                            numTotalPrice += self.numCalculateSubTotal(cartItem.Quantity, itemPriceDefault, corePrice);
                            break;
                        case 1:
                            numTotalPrice += self.numCalculateSubTotal(cartItem.Quantity, itemPriceDefault, 0);
                            break;
                        case 2:
                            numTotalPrice += self.numCalculateSubTotal(cartItem.Quantity, 0, corePrice);
                            break;
                    }
                });
            }
        }
        else {
            this.state.cartObject.forEach(function(cartItem, index){
                var corePriceCF = cartItem.ItemDetail.CustomFields.find(cf => cf.Name == "Precio Core");
                var corePrice = 0.0;
                var itemPriceDefault = cartItem.ItemDetail.Price;
                if(corePriceCF != null){
                    if(corePriceCF.Values[0].length > 0){
                        corePrice = parseFloat(corePriceCF.Values[0]);
                    }
                }
                let currencyCodeCf = cartItem.ItemDetail.CustomFields.find(x => x.Name == "Currency");
                let strCurrencyCode = "";
                if (currencyCodeCf != undefined || currencyCodeCf != null) {
                    if(currencyCodeCf.Values[0].length > 0){
                        strCurrencyCode = currencyCodeCf.Values[0];
                    }
                }
                //All prices in MXN at first
                if (
                    strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                    self.state.currentCurrency == "MXN" && (cartItem.ItemDetail.boolPriceChanged == undefined || cartItem.ItemDetail.boolPriceChanged == false)
                    )
                {
                    itemPriceDefault = itemPriceDefault * parseFloat(self.state.currentExchange);
                }

                if (
                    strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                    self.state.currentCurrency == "MXN"
                    )
                {
                    corePrice = corePrice * parseFloat(self.state.currentExchange);
                }

                switch (intCalculationType_I) {
                    case 0:
                        numTotalPrice += self.numCalculateSubTotal(cartItem.CartQty, itemPriceDefault, corePrice);
                        break;
                    case 1:
                        numTotalPrice += self.numCalculateSubTotal(cartItem.CartQty, itemPriceDefault, 0);
                        break;
                    case 2:
                        numTotalPrice += self.numCalculateSubTotal(cartItem.CartQty, 0, corePrice);
                        break;
                }
            });
        }

        return numTotalPrice;
    }


    intGetTotalQuantity(
        props_I = null
    )
    {
        var intTotalQty = 0;
        if(props_I != null){
            if (props_I.cartPageModel.cartList && props_I.cartPageModel.cartList.length > 0) {
                props_I.cartPageModel.cartList.forEach(function(cartItem, parentIndex){
                    intTotalQty += parseInt(cartItem.Quantity);
                });
            }
        }
        else {
            this.state.cartObject.forEach(function(cartItem, index){
                intTotalQty += parseInt(cartItem.CartQty);
            });
        }

        return intTotalQty;
    }

    getTotalWeight(props_I = null)
    {
        var totalWeight = 0;
        if(props_I != null){
            if (props_I.cartPageModel.cartList && props_I.cartPageModel.cartList.length > 0) {
                props_I.cartPageModel.cartList.forEach(function(cartItem, parentIndex){
                    var itemWeightUnit = cartItem.ItemDetail.WeightUnit ? cartItem.ItemDetail.WeightUnit : "kgs";
                    var itemWeight = cartItem.ItemDetail.Weight ? cartItem.ItemDetail.Weight : 0;
                    if(itemWeightUnit == "lbs"){
                        itemWeight = Number.parseFloat(itemWeight / 2.2046).toFixed(2);
                    }
                    totalWeight += parseInt(cartItem.Quantity) * itemWeight;
                });
            }
        }
        else {
            this.state.cartObject.forEach(function(cartItem, index){
                var itemWeightUnit = cartItem.ItemDetail.WeightUnit ? cartItem.ItemDetail.WeightUnit : "kgs";
                var itemWeight = cartItem.ItemDetail.Weight ? cartItem.ItemDetail.Weight : 0;
                if(itemWeightUnit == "lbs"){
                    itemWeight = Number.parseFloat(itemWeight / 2.2046).toFixed(2);
                }
                totalWeight += parseInt(cartItem.CartQty) * itemWeight;
            });
        }

        return totalWeight;
    }


    couponfeature() {
    var couponValue = $('#inputCoupon').val();
    var data = { promocode: couponValue };
    var couponDiscountVar = 0;
    var strApiUrl = "https://" + process.env.BASE_URL + "/user/plugins/" + process.env.CUPONES_PLUGIN + "/get_coupon_discount.php";
      $.ajax({
        url: strApiUrl,
        method: "POST",
        contentType: "application/json",
        data: JSON.stringify(data),
        success: async (result) => {
            var coupondetails = JSON.parse(result);
            // console.log(coupondetails);
            if (coupondetails.result.length == 0) {
                toastr.error("Cupón Inválido");
            } else {
                if (coupondetails.result[0].DateBegin === "" && coupondetails.result[0].DateEnd === "") {
                    couponDiscountVar = coupondetails.result[0].DiscountValue;
                    if(coupondetails.result[0].IsLimited == 1) {
                        if(coupondetails.result[0].Quantity < coupondetails.result[0].MaxRedeem){
                            this.couponValidated(couponDiscountVar, coupondetails);
                        } else {
                            toastr.error("Cupón Agotado");
                        }
                    } else {
                        if(coupondetails.result[0].FirstPurchase === 1) {
                            const fulfilmentStatuses = ['created', 'ready for consumer collection', 'delivered', 'collected', 'acknowledged', 'completed', 'cancelled'];
                            const pStatus = 'success,waiting for payment,acknowledged,pending,processing';
                            const promiseHistory = new Promise((resolve, reject) => {
                                const options = {
                                    userId: this.props.user.ID,
                                    keyword: '',
                                    pageNumber: 1,
                                    pageSize: 20,
                                    status: fulfilmentStatuses,
                                    pStatus: pStatus
                                };
                                client.Transactions.getTransactionsByBuyerFulfilment(options.userId, options.pageSize, options.pageNumber, options.keyword, null, null, "", function (err, result) {
                                    resolve(result);
                                });
                            });
                            await promiseHistory.then((res) => {
                                console.log(Number(res['TotalRecords']))
                                if (res &&
                                    res['TotalRecords'] !== undefined &&
                                    res['TotalRecords'] !== null &&
                                    Number(res['TotalRecords']) === 0) {
                                    this.couponValidated(couponDiscountVar, coupondetails);
                                } else {
                                    toastr.error("Cupón Inválido, ya hay pedidos registrados anteriormente");
                                }
                            }).catch((error) => {
                                console.info(error);
                                toastr.error("Ha ocurrido un error en el proceso, intente nuevamente.");
                            });
                        } else {
                            this.couponValidated(couponDiscountVar, coupondetails);
                        }
                    }
                } else {
                    if(coupondetails.result[0].DateBegin === "" || coupondetails.result[0].DateEnd === "") {
                        toastr.error("Cupón Inválido");
                    } else {
                        const currentDate = new Date(); // Obtener la fecha actual sin las horas
                        // console.log(currentDate);
                        const dateBegin = new Date(coupondetails.result[0].DateBegin);
                        dateBegin.setDate(dateBegin.getDate() + 1);
                        dateBegin.setHours(0, 0, 0, 0);
                        // console.log(dateBegin);
                        const dateEnd = new Date(coupondetails.result[0].DateEnd);
                        dateEnd.setDate(dateEnd.getDate() + 1);
                        dateEnd.setHours(23, 59, 59, 999);
                        // console.log(dateEnd);
                        if (currentDate >= dateBegin && currentDate <= dateEnd) {
                            couponDiscountVar = coupondetails.result[0].DiscountValue;
                            if(coupondetails.result[0].IsLimited == 1) {
                                if(coupondetails.result[0].Quantity < coupondetails.result[0].MaxRedeem){
                                    if(coupondetails.result[0].FirstPurchase === 1) {
                                        const fulfilmentStatuses = ['created', 'ready for consumer collection', 'delivered', 'collected', 'acknowledged', 'completed', 'cancelled'];
                                        const pStatus = 'success,waiting for payment,acknowledged,pending,processing';
                                        const promiseHistory = new Promise((resolve, reject) => {
                                            const options = {
                                                userId: this.props.user.ID,
                                                keyword: '',
                                                pageNumber: 1,
                                                pageSize: 20,
                                                status: fulfilmentStatuses,
                                                pStatus: pStatus
                                            };
                                            client.Transactions.getTransactionsByBuyerFulfilment(options.userId, options.pageSize, options.pageNumber, options.keyword, null, null, "", function (err, result) {
                                                resolve(result);
                                            });
                                        });
                                        await promiseHistory.then((res) => {
                                            if (res &&
                                                res['TotalRecords'] !== undefined &&
                                                res['TotalRecords'] !== null &&
                                                Number(res['TotalRecords']) === 0) {
                                                this.couponValidated(couponDiscountVar, coupondetails);
                                            } else {
                                                toastr.error("Cupón Inválido, ya hay pedidos registrados anteriormente");
                                            }
                                        }).catch((error) => {
                                            console.info(error);
                                            toastr.error("Ha ocurrido un error en el proceso, intente nuevamente.");
                                        });
                                    } else {
                                        this.couponValidated(couponDiscountVar, coupondetails);
                                    }
                                }else{
                                    toastr.error("Cupón Agotado");
                                }
                            } else {
                                if(coupondetails.result[0].FirstPurchase === 1) {
                                    const fulfilmentStatuses = ['created', 'ready for consumer collection', 'delivered', 'collected', 'acknowledged', 'completed', 'cancelled'];
                                    const pStatus = 'success,waiting for payment,acknowledged,pending,processing';
                                    const promiseHistory = new Promise((resolve, reject) => {
                                        const options = {
                                            userId: this.props.user.ID,
                                            keyword: '',
                                            pageNumber: 1,
                                            pageSize: 20,
                                            status: fulfilmentStatuses,
                                            pStatus: pStatus
                                        };
                                        client.Transactions.getTransactionsByBuyerFulfilment(options.userId, options.pageSize, options.pageNumber, options.keyword, null, null, "", function (err, result) {
                                            resolve(result);
                                        });
                                    });
                                    await promiseHistory.then((res) => {
                                        if (res &&
                                            res['TotalRecords'] !== undefined &&
                                            res['TotalRecords'] !== null &&
                                            Number(res['TotalRecords']) === 0) {
                                            this.couponValidated(couponDiscountVar, coupondetails);
                                        } else {
                                            toastr.error("Cupón Inválido, ya hay pedidos registrados anteriormente");
                                        }
                                    }).catch((error) => {
                                        console.info(error);
                                        toastr.error("Ha ocurrido un error en el proceso, intente nuevamente.");
                                    });
                                } else {
                                    this.couponValidated(couponDiscountVar, coupondetails);
                                }
                            }
                        } else {
                            toastr.error("Cupón no válido para la fecha actual");
                        }
                    }
                }
            }
        },
        error: function (jqXHR, status, err) { },
      });
      this.applyDiscount();
	}

    couponValidated(couponDiscountVar, coupondetails) {
        if(typeof window !== 'undefined'){
            this.setState({"cuponDiscount": couponDiscountVar});
            this.setState({"cuponTypeDiscount": coupondetails.result[0].DiscountType});
            this.setState({ "cuponUseEnabled": 1 });
            $('#inputCoupon').prop('disabled', true);
            const btnApply = document.getElementById('btnApplyCouponBtn');
            btnApply.classList.add('hide');
            const btnCancel = document.getElementById('btnCancelCouponBtn');
            btnCancel.classList.remove('hide');
            toastr.success("Cupón Validado");
        }
    }

    applyDiscount() {
        let cartObject = [...this.state.cartObject]; // Clone the cart object to avoid direct state mutation
        const { cuponDiscount, cuponTypeDiscount, shippingDataCalculation } = this.state;
        let totalDiscount = cuponDiscount;
        let discountPerItem = 0;
        let eligibleItemsTotal = 0;

        // Calculate total of eligible items (exclude shipping if present)
        cartObject.forEach((item) => {
            if (!item.isShipping) {
                eligibleItemsTotal += item.OriginalPrice * item.CartQty;
            }
        });

        if (cuponTypeDiscount === "amount") {
            // Distribute amount evenly across all eligible items
            discountPerItem = totalDiscount / eligibleItemsTotal;
        }

        // Apply discount to each eligible item and update observations
        cartObject = cartObject.map((item) => {
            if (!item.isShipping) {
                let discount = cuponTypeDiscount === "percentage" ? item.OriginalPrice * (totalDiscount / 100) : item.OriginalPrice * discountPerItem;
                return {
                    ...item,
                    DiscountedPrice: item.OriginalPrice - discount,
                    Observations: `Coupon applied: ${cuponTypeDiscount === "percentage" ? totalDiscount + '%' : '$' + totalDiscount}`
                };
            }
            console.log('Observaciones', item.Observations);
            return item;
        });

        // Update state with the new cartObject
        this.setState({ cartObject });
    }

    couponfeaturedisable = () => {
        if(typeof window !== 'undefined'){
            let self = this;
            if(this.state.cuponDiscount > 0){
                $('#inputCoupon').prop('disabled', false);
                $('#inputCoupon').val("");
                var numTotal = (self.state.numItemPriceTotal + self.state.numItemCoreTotal) + self.numCalculateIVA(self.state.numBaseIVA, self.state.numItemPriceTotal, self.state.numItemCoreTotal);
                $('#calculated-amount-total').text(numTotal.toFixed(2));
                this.setState({ "cuponDiscount": 0 });
                this.setState({ "cuponUseEnabled": 0 });
                const btnApply = document.getElementById('btnApplyCouponBtn');
                btnApply.classList.remove('hide');
                const btnCancel = document.getElementById('btnCancelCouponBtn');
                btnCancel.classList.add('hide');
                toastr.success("Cupón Borrado");
            }
        }
    }

    numCalculateTotalWithIVA=(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I, numCuponValue_I = 0, shipmentValue = 0) => {        
        var numTotalText;
        var numTotal = 0;
        //var userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";

        var userIsB2C = true;
        if(!this.props.user.Guest) {
            userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
        }

        if (numCuponValue_I > 0) {
            if(this.state.cuponTypeDiscount == "percentage"){
                var discountPercentage = numCuponValue_I / 100;
                // numTotal = numTotal - (numTotal * discountPercentage);
                numItemPriceTotal_I = numItemPriceTotal_I - (numItemPriceTotal_I * discountPercentage)
                numTotal = (numItemPriceTotal_I + numItemCoreTotal_I ) + this.numCalculateIVA(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I);
                numTotal = numTotal + shipmentValue;
            }else{
                numTotal = (numItemPriceTotal_I + numItemCoreTotal_I) + this.numCalculateIVA(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I);
                numTotal = numTotal - numCuponValue_I;
                numTotal = numTotal + shipmentValue;
            }
        } else {
            numTotal = (numItemPriceTotal_I + numItemCoreTotal_I) + this.numCalculateIVA(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I);
            if(userIsB2C){
                numTotal = numTotal + shipmentValue;
            }
        }

        if(!userIsB2C){
            numTotal = (numItemPriceTotal_I + numItemCoreTotal_I) + this.numCalculateIVA(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I);
            $('.cuponFeaturePlace').css('display', 'none');
            $('.bp-order-summary-coupon-button').css('display', 'none');
            $('.bp-order-summary-coupon-button-disable').css('display', 'none');
            $('#cuponFeaturePlaceLine').css('display', 'none');
        }

        numTotalText = this.subFormatMoney(numTotal);
        $('#calculated-amount-total').text(numTotalText);

        return numTotal;
    }

    /* Previous numCalculateTotalWithIVA function */

    // numCalculateTotalWithIVA=(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I, numCuponValue_I = 0, shipmentValue = 0) => {
    //     var numTotal = (numItemPriceTotal_I + numItemCoreTotal_I) + this.numCalculateIVA(numBaseIVA_I, numItemPriceTotal_I, numItemCoreTotal_I);
    //     const userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
    //     if (numCuponValue_I > 0) {
    //         if(this.state.cuponTypeDiscount == "percentage"){
    //             var numTotalText;
    //             var discountPercentage = numCuponValue_I / 100;
    //             numTotal = numTotal - (numTotal * discountPercentage);
    //             numTotal = numTotal + shipmentValue;
    //             numTotalText = this.subFormatMoney(numTotal);
    //             $('#calculated-amount-total').text(numTotalText);
    //         }else{
    //             var numTotalText;
    //             numTotal = numTotal - numCuponValue_I;
    //             numTotal = numTotal + shipmentValue;
    //             numTotalText = this.subFormatMoney(numTotal);
    //             $('#calculated-amount-total').text(numTotalText);
    //         }
    //     } else {
    //         var numTotalText;
    //         if(userIsB2C){
    //             numTotal = numTotal + shipmentValue;
    //         }
    //         numTotalText = this.subFormatMoney(numTotal);
    //         $('#calculated-amount-total').text(numTotalText);
    //     }
    //     if(userIsB2C){

    //     }else{
    //         $('.cuponFeaturePlace').css('display', 'none');
    //         $('.bp-order-summary-coupon-button').css('display', 'none');
    //         $('.bp-order-summary-coupon-button-disable').css('display', 'none');
    //         $('#cuponFeaturePlaceLine').css('display', 'none');
    //         var numTotalText;
    //         numTotalText = this.subFormatMoney(numTotal);
    //         $('#calculated-amount-total').text(numTotalText);
    //     }
    //     return numTotal;
    // }



    unformatMoney(numMoney_I){
        return numMoney_I.replace(/[^0-9.-]+/g,"");
    }

    numCalculateIVA(numBaseIVA_I,numItemPriceTotal_I,numItemCoreTotal_I)
    {
        if(typeof window !== 'undefined'){
            // In order to avoid missing decimal due float in JS, multiply it by 100 (AKA two decimal to the left of the dot)
            var postcode = parseInt(document.getElementById('address-zipcode').innerText);
            const postNumbers = [];
            for (let i = 32000; i <= 32730; i++) {
                postNumbers.push(i);
            }

            //if(postNumbers.includes(postcode)) {
            //	numBaseIVA_I = 0.08
            //}

            return numBaseIVA_I * ( (numItemPriceTotal_I + numItemCoreTotal_I) * 100) / 100 ;
        }
    }

    numCalculateSingleIVA(numBaseIVA_I,numTotalPrice_I)
    {
        if(typeof window !== 'undefined'){
            // In order to avoid missing decimal due float in JS, multiply it by 100 (AKA two decimal to the left of the dot)
            var postcode = parseInt(document.getElementById('address-zipcode').innerText);
            const postNumbers = [];
            for (let i = 32000; i <= 32730; i++) {
                postNumbers.push(i);
            }

            //if(postNumbers.includes(postcode)) {
            //	numBaseIVA_I = 0.08
            //}

            return numBaseIVA_I * numTotalPrice_I;
        }
    }

    //                                                     //ACTUALIZAR estado de los totales
    setTotals(callback_I = null){
        this.setState({"intTotalQuantities":this.intGetTotalQuantity()});
        this.setState({"getTotalWeight":this.getTotalWeight()});
        this.setState({"numTotalOrder":this.numGetOrderTotal()}, () => {
            if(callback_I != null){
                callback_I();
            }
        });
    }


    itemUrl(itemName, itemId) {
        return "/items/" + this.generateSlug(itemName) + "/" + itemId;
    }

    arrangeMerchants() {
        let self = this;
        let merchantsIds = [];
        let arrangedCartItems = [];
        if (this.props.cartPageModel.cartList) {
            //Filtering Merchants
            this.props.cartPageModel.cartList.forEach(function (cart) {
                if (merchantsIds.length > 0) {
                    if (merchantsIds.includes(cart.ItemDetail.MerchantDetail.ID) > 0) {
                        merchantsIds.splice($.inArray(cart.ItemDetail.MerchantDetail.ID, merchantsIds), 1);
                        merchantsIds.push(cart.ItemDetail.MerchantDetail.ID);
                    } else {
                        merchantsIds.push(cart.ItemDetail.MerchantDetail.ID);
                    }
                } else if (merchantsIds.length === 0) {
                    merchantsIds.push(cart.ItemDetail.MerchantDetail.ID);
                }
            });
            //Arranging Items
            merchantsIds.forEach(function (merchantId) {
                let merchantItems = [];
                self.props.cartPageModel.cartList.forEach(function (cart) {
                    if (merchantId === cart.ItemDetail.MerchantDetail.ID) {
                        merchantItems.push(cart);
                    }
                });
                arrangedCartItems.push(merchantItems);
            });

        }
        self.props.arrangeItemCarts(arrangedCartItems);
    }

    subExchangeCurrencyLookup()
    {
        let numExchangeCurrency = $("#exchange-currency").attr("currency");
        if (
            numExchangeCurrency != null && numExchangeCurrency != "-"
            )
        {
            this.setState({"currentExchange":parseFloat(numExchangeCurrency)}, () => {
                //First Re-Calculate totals since currency probably was not instanced at rendering
                // for first time.
                context.totalOrderCalculated = context.numRecalculateTotalFromCartObject(context.state.cartObject, 0);
                context.setState({"numTotalOrder":context.totalOrderCalculated});
                context.totalItemPriceCalculated = context.numRecalculateTotalFromCartObject(context.state.cartObject, 1);
                context.setState({"numItemPriceTotal":context.totalItemPriceCalculated});
                context.totalItemCorePriceCalculated = context.numRecalculateTotalFromCartObject(context.state.cartObject, 2);
                context.setState({"numItemCoreTotal":context.totalItemCorePriceCalculated});

                /* LOGS INICIO */

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "Se obtuvo tipo de cambio: " + parseFloat(numExchangeCurrency)
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {

                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

				}, error => {

				});

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "numTotalOrder: " + context.totalOrderCalculated
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

				}, error => {

				});

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "numItemPriceTotal: " + context.totalItemPriceCalculated
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

				}, error => {

				});

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "numItemCoreTotal: " + context.totalItemCorePriceCalculated
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

				}, error => {
					console.log(error);
				});
                /* LOGS FIN */

                //Check address Id from cookies once get user Id
                client.Users.getUserDetails({
                    excludeToken: false,
                    userId: context.props.user.ID,
                    includeUserCustomFields: true
                }, function(err, user){
                    if(err == null && user != null){
                        context.props.user.CustomFields = user.CustomFields;
                        context.getAddressIdFromCookies();
                    }
                });
            });
        }
        else
        {
            var currentExchange = this.getCookie('CurrentExchange');
            if (currentExchange == undefined) {
                setTimeout( () => {
                    this.subExchangeCurrencyLookup();
                }, 500);
            } else {
                document.querySelectorAll("#exchange-currency").forEach(el => {
                    el.setAttribute("currency", currentExchange);
                    el.textContent = "$ " + currentExchange;
                });
                this.setState({"currentExchange":parseFloat(currentExchange)}, () => {
                    //First Re-Calculate totals since currency probably was not instanced at rendering
                    // for first time.
                    context.totalOrderCalculated = context.numRecalculateTotalFromCartObject(context.state.cartObject, 0);
                    context.setState({"numTotalOrder":context.totalOrderCalculated});
                    context.totalItemPriceCalculated = context.numRecalculateTotalFromCartObject(context.state.cartObject, 1);
                    context.setState({"numItemPriceTotal":context.totalItemPriceCalculated});
                    context.totalItemCorePriceCalculated = context.numRecalculateTotalFromCartObject(context.state.cartObject, 2);
                    context.setState({"numItemCoreTotal":context.totalItemCorePriceCalculated});

                    /* LOGS INICIO */
                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "Se obtuvo tipo de cambio: " + parseFloat(currentExchange)
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {

                    });

                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "numTotalOrder: " + context.totalOrderCalculated
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {

                    });

                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "numItemPriceTotal: " + context.totalItemPriceCalculated
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {
                    });

                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "numItemCoreTotal: " + context.totalItemCorePriceCalculated
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {
                    });
                    /* LOGS FIN */

                    //Check address Id from cookies once get user Id
                    client.Users.getUserDetails({
                        excludeToken: false,
                        userId: context.props.user.ID,
                        includeUserCustomFields: true
                    }, function(err, user){
                        if(err == null && user != null){
                            context.props.user.CustomFields = user.CustomFields;
                            context.getAddressIdFromCookies();
                        }
                    });
                });
            }
        }
    }

    componentDidMount() {
        context = this;
        var self = this;
        self.arrangeMerchants();
        self.subExchangeCurrencyLookup();
        self.getUserAddresses();

        client.Addresses.getUserAddresses(self.props.user.ID, function(err, addresses){
            if (addresses != null && addresses.Records != null && addresses.Records.length > 0)
            {
                self.setState({"arrAddresses" : addresses.Records});
                self.renderAddressesOptions();
                context.subSetOptionAddressSelected();
            }
        });

        self.getShippingMethods();
        //                                 //Inicializar variables branch y depot usando servicios.
		self.setUserDefaultAddress();

        self.getOccurAddresses();
        //                                                  //Once loaded the component, blok UI until everything
        //                                                  //      was loaded.
        if (self.state.cartObject.length > 0)
        {
            $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Calculando precios y existencias, por favor espere...' });
        }

        //Check If Have Guest
        if (self.props.user && self.props.user.Guest === true && CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
            self.props.user.ID = CommonModule.getCookie("guestUserID");
        }

        //Set div listeners.
        $("#btnRemoveItem").on("click", function(){
            self.deleteItemFromCart();
        });

        $("#btnRemoveItemUnit").on("click", function(){
            self.deleteItemFromCart();
        });

        $("#btnAllowBackOrder").on("click", function(){
            //Hide Modal
            $("#modalBackorderGrant").modal('toggle');
            //Allowing backorder
            self.boolAvailabilityCheckDisabled = true;
            var itemToUpdate = $("#ipt-itemToUpdate").val();
            var deltaUpdate = $("#ipt-itemToUpdate").attr("deltaupdate");
            if(deltaUpdate != "NA"){
                self.updateItemQuantity(itemToUpdate, deltaUpdate);
            }else{
                self.itemOnChangeListener(itemToUpdate);
            }
        });

        $("#btn-cancel-backorder").on("click", function(){
            //Hide Modal
            $("#modalBackorderGrant").modal('toggle');

            //If quantity is greater than availability, set original quantity to it.
            var itemToUpdate = $("#ipt-itemToUpdate").val();
            var deltaUpdate = $("#ipt-itemToUpdate").attr("deltaupdate");
            if(deltaUpdate == "NA"){
                var cartItemQty = self.resolveItemCartObject(itemToUpdate).CartQty;
                $("#ipt-" + itemToUpdate).val(cartItemQty);
            }
        });

        //                                                                  //listener when order type selector changes.
        //                                                                  //llama cuando se ajusta el tipo de pedido.
        $("#select-order-type").on("change", function(){
            $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios para el tipo de pedido seleccionado...' });
            context.subReloadOrderTypesInTable(this);
            context.getSalePrices();
        });

        this.getOccurAddresses();

        $("#shipping-methods").on("change", function() {
            if(typeof window !== 'undefined'){
                let selector = this;
                let selectShipping = document.getElementById("shipping-addresses");
                selectShipping.disabled = true;

                if (selector.options[selector.selectedIndex].innerText == "Envío Terrestre - Ocurre Oficina Transportista") {
                    context.setState({boolHideShippingDiv:true});
                    $("#ocurre-div").show();
                    $("#sucursal-div").hide();
                } else if (selector.options[selector.selectedIndex].innerText == "Envío Terrestre - Entrega a domicilio") {
                    context.setState({boolHideShippingDiv:false});
                    $("#ocurre-div").hide();
                    $("#sucursal-div").hide();
                    selectShipping.disabled = false;
                } else if (selector.options[selector.selectedIndex].innerText == "Recoger en Sucursal Megamak") {
                    context.setState({boolHideShippingDiv:true});
                    $("#sucursal-div").show();
                    $("#ocurre-div").hide();
                }
                context.setState({shippingRates:null});
                context.getCalculationType();
            }
        });

        $("#billing-addresses").on("change", function(){
            var userIsB2C = true;
            if(!self.props.user.Guest) {
                userIsB2C = self.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
            }

            if(userIsB2C) {
                if(typeof window !== 'undefined'){
                    let billingSelectorAddress = document.getElementById("billing-addresses");
                    let selectedBillingAddress = billingSelectorAddress.options[billingSelectorAddress.selectedIndex].id;
                            
                    client.Addresses.getUserAddress(self.props.user.ID, selectedBillingAddress, function(err, addresses){
                        if (addresses != null)
                        {
                            var postcode = parseInt(addresses.PostCode);
                            const postNumbers = [];
                            for (let i = 32000; i <= 32730; i++) {
                                postNumbers.push(i);
                            }

                            if(postNumbers.includes(postcode)) {
                                console.log("FinalDistribution main");
                                var finalWarehouse = document.getElementById("sucFin").value.split(',');

                                if(finalWarehouse.includes("MEGAMAK CD JUAREZ")) {
                                    context.setState({numBaseIVA: 0.08});
                                    $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios...' });
                                    //context.subReloadOrderTypesInTable(self);
                                    context.getSalePrices();
                                }
                            } else {
                                if(self.state.numBaseIVA != 0.16) {
                                    context.setState({numBaseIVA: 0.16});
                                    $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios...' });
                                    //context.subReloadOrderTypesInTable(self);
                                    context.getSalePrices();
                                }
                            }
                        }
                    });
                }
            }
		});

        const myCheckbox = document.getElementById('billing-required');
        if(myCheckbox) { 
            myCheckbox.addEventListener('change', function() {
                if (myCheckbox.checked) {
                    var userIsB2C = true;
                    if(!self.props.user.Guest) {
                        userIsB2C = self.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                    }

                    if(userIsB2C) {
                        if(typeof window !== 'undefined'){
                            let billingSelectorAddress = document.getElementById("billing-addresses");
                            let selectedBillingAddress = billingSelectorAddress.options[billingSelectorAddress.selectedIndex].id;
                                    
                            client.Addresses.getUserAddress(self.props.user.ID, selectedBillingAddress, function(err, addresses){
                                if (addresses != null)
                                {
                                    var postcode = parseInt(addresses.PostCode);
                                    const postNumbers = [];
                                    for (let i = 32000; i <= 32730; i++) {
                                        postNumbers.push(i);
                                    }

                                    if(postNumbers.includes(postcode)) {
                                        console.log("FinalDistribution main");
                                        var finalWarehouse = document.getElementById("sucFin").value.split(',');

                                        if(finalWarehouse.includes("MEGAMAK CD JUAREZ")) {
                                            context.setState({numBaseIVA: 0.08});
                                            $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios...' });
                                            //context.subReloadOrderTypesInTable(self);
                                            context.getSalePrices();
                                        }
                                    } else {
                                        if(self.state.numBaseIVA != 0.16) {
                                            context.setState({numBaseIVA: 0.16});
                                            $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios...' });
                                            //context.subReloadOrderTypesInTable(self);
                                            context.getSalePrices();
                                        }
                                    }
                                }
                            });
                        }
                    }
                } else {
                    console.log('Checkbox is unchecked!');
                }
            });
        }

        //Enter key listener to inputs, just to trigger blur event when enter key is pressed.
        if(typeof window !== 'undefined'){
            document.addEventListener('keypress', function (e) {
                if (e.key === 'Enter') {
                    $(e.path[0]).blur();
                }
            });
        }

        //Init stepper handler
        stepperHandler = new StepperControl('.stepper-progress-bar');
        this.getOccurAddresses();

        setTimeout(function() {
            if(typeof window !== 'undefined'){
                if(document.getElementsByClassName('blockUI blockMsg blockPage')) {
                    if(document.getElementsByClassName('blockUI blockMsg blockPage')[0]) {
                        if(document.getElementsByClassName('blockUI blockMsg blockPage')[0].innerText == "Calculando precios y existencias, por favor espere...") {
                            $.unblockUI();
                            toastr.success("Precios actualizados con éxito...");
                        }
                    }
                }
            }
        }, 30000);

        window.gtag("event", "begin_checkout", {
            'app_name': 'Megamak'
        });
    }

    availabilityItemQtyTotal(){
        console.log("availabilityItemQtyTotal");
        this.state.arrAvailabilitiesforItem.forEach((item) => {
            if(item.cartItemQty > item.totalAvailability){
                var input = $("#ipt-" + item.itemDetail);
                input.val(0);
                toastr.error("La cantidad solicitada no está disponible");
            }
            this.itemOnChangeListener(item.itemDetail);
        });
    }

    loadAndSetBillingAddressIdFromAddress(
        strAddressId_I
    )
    {
        if (
            strAddressId_I
            )
        {
            var userId = this.props.user.ID != null ? this.props.user.ID : "";

            //Prepare promise for warehouses collection
            const promiseSucursales = new Promise((resolve, reject) => {
                const options = {
                    pluginId: this.packageIdAlmacenes,
                    tableName: "Almacenes",
					query: [
						{
							Name: 'IsActive',
							Operator: "eq",
							Value: "true"
						}
					]
                };

                client.CustomTables.searchCustomTable(options, function (err, result) {
                    resolve(result);
                });
            });

            //Prepare promise for warehouses coonfiguration
            const promiseUserConfiguration = new Promise((resolve, reject) => {
                const options = {
                    pluginId: this.packageIdAlmacenes,
                    tableName: "ConfiguracionUsuario",
                    query: [
                        {
                            Name: "UserId",
                            Operator: "equal",
                            Value: userId
                        },
                        {
                            Name: "AddressId",
                            Operator: "equal",
                            Value: strAddressId_I
                        }
                    ]
                };

                client.CustomTables.searchCustomTable(options, function (err, result) {
                    resolve(result);
                });
            });

            Promise.all([promiseSucursales, promiseUserConfiguration]).then(response => {
                let strBranchId = null;
                let otherBranch = null;
                if (
                    response[0].Records.length > 0 && response[1].Records.length > 0
                    )
                {
                    //                                      //To easy code.
                    let arrAlmacenes = response[0].Records;
                    let configObj = response[1].Records[0];
                    for (let intIndex = 0; intIndex < arrAlmacenes.length; intIndex++) {
                        const almacen = arrAlmacenes[intIndex];
                        if (
                            almacen.Nombre == configObj.AlmacenFacturacion
                            )
                        {
                            strBranchId = almacen.LiderId;
                            otherBranch = almacen.BrachId;
                            break;
                        }
                    }
                }

                if (
                    strBranchId != null
                    )
                {
                    //                                      //Overriding widget values.
                    if(typeof window !== 'undefined'){
                        document.getElementById("address-name").setAttribute("billing-address-branch", otherBranch);
                        document.getElementById("address-name").setAttribute("billing-address-lider", strBranchId);
                        document.getElementById("address-name").setAttribute("addressid", strAddressId_I);
                    } else {
                        setInterval(function () {
                            if(typeof window !== 'undefined'){
                                document.getElementById("address-name").setAttribute("billing-address-branch", otherBranch);
                                document.getElementById("address-name").setAttribute("billing-address-lider", strBranchId);
                                document.getElementById("address-name").setAttribute("addressid", strAddressId_I);
                            }
	                    }, 1000);
                    }

                    /* LOGS INICIO */
                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "Branch Id: " + strBranchId
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {

                    }, error => {
                        console.log(error);
                    });

                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "Address Id: " + strAddressId_I
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {

                    }, error => {
                        console.log(error);
                    });
                    /* LOGS FIN */
                }
                else
                {
                    $.unblockUI();
                    toastr.error("Error recalculando precios y existencias, inténtelo más tarde.");

                    /* LOGS INICIO */
                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "Branch Id: ERROR: " + strBranchId
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {

                    }, error => {
                        console.log(error);
                    });
                    /* LOGS FIN */
                }
            });
        }
    }

    getOccurAddressesServices(branchID, depotID){
        if(this.state.cartObject.length > 0){
            var options = {
                pluginId: this.packageIdTrazabilidad,
                tableName: "Trazabilidad",
            };

            client.CustomTables.searchCustomTable(options, function (err, result) {
                if(err == null){
                    let boolAtLeastOneOccurRecord= false;
                    let selector = $("#select-occur-addresses");
                    //                                      //Clean select options rendered previously.
                    selector.empty();

                    //                                      //This attribute is taken from address widget.
                    if(typeof window !== 'undefined'){
                        let liderId = document.getElementById("address-name").getAttribute("billing-address-lider");
                    
                        // console.log("liderId", liderId);

                        // console.log("this.os_depotId THIS ONE", depotID);
                        // console.log("this.os_branchId", branchID);

                        if(liderId == null) {
                            liderId = depotID;
                        }

                        result.Records.forEach(row => {
                            if (
                                row.Branches.includes(liderId) && row.IsActive == 1 && row.ItOccurEnabled
                                )
                            {
                                boolAtLeastOneOccurRecord = true;
                                selector.append(
                                    `<option value="${row.ExternalCode}">${row.DisplayName}</option>`
                                );
                            }
                        });
                    }

                    context.setState({boolOccurLocationNotAvailable: !boolAtLeastOneOccurRecord});

                    if (
                        !boolAtLeastOneOccurRecord
                        )
                    {
                        selector.append(
                            `<option value="-1" defaultValue>No disponible en tu sucursal seleccionada</option>`
                        );
                    }
                }
            });
        }
    }

    getOccurAddresses(){
        if(this.state.cartObject.length > 0){
            var options = {
                pluginId: this.packageIdTrazabilidad,
                tableName: "Trazabilidad",
            };

            client.CustomTables.searchCustomTable(options, function (err, result) {
                if(err == null){
                    let boolAtLeastOneOccurRecord= false;
                    let selector = $("#select-occur-addresses");
                    //                                      //Clean select options rendered previously.
                    selector.empty();

                    //                                      //This attribute is taken from address widget.
                    if(typeof window !== 'undefined'){
                        let liderId = document.getElementById("address-name").getAttribute("billing-address-lider");
                        // console.log("liderId", liderId);

                        result.Records.forEach(row => {
                            if (
                                row.Branches.includes(liderId) && row.IsActive == 1 && row.ItOccurEnabled
                                )
                            {
                                boolAtLeastOneOccurRecord = true;
                                selector.append(
                                    `<option value="${row.ExternalCode}">${row.DisplayName}</option>`
                                );
                            }
                        });
                    }

                    context.setState({boolOccurLocationNotAvailable: !boolAtLeastOneOccurRecord});

                    if (
                        !boolAtLeastOneOccurRecord
                        )
                    {
                        selector.append(
                            `<option value="-1" defaultValue>No disponible en tu sucursal seleccionada</option>`
                        );
                    }
                }
            });
        }
    }

    subReloadOrderTypesInTable(selector){
        this.state.cartObject.forEach(function(cartItem, index){
            if(cartItem.ItemDetail.ID != null || cartItem.ItemDetail.ID != ""){
                //get selector for order types on table from span id
                var spanSelector = $("#ordt-"+cartItem.ItemDetail.ID);
                if(spanSelector != null && spanSelector.text().toLowerCase() != "oferta"){
                    let textSelected = selector.value.toLowerCase();
                    textSelected = textSelected.charAt(0).toUpperCase() + textSelected.slice(1);
                    spanSelector.text(textSelected);
                }
            }
        });
    }

    openAvailabilityModal(strInputId_I)
    {
        //var userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";

        var userIsB2C = true;
        if(!this.props.user.Guest) {
            userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
        }

        if($("#a-" + strInputId_I).text() != "-" || userIsB2C){
            let cartItem = this.resolveItemCartObject(strInputId_I);
            var textToDisplay = "";
            if(cartItem != null){
                textToDisplay = cartItem.ItemDetail.Name;
            }
            this.setState({"strSelectedPartCode":textToDisplay});
            let rows = this.renderAvailabilityModalCells(strInputId_I);
        }
        else if ($("#a-" + strInputId_I).text() == "-" && this.state.arrAvailabilityParts.length > 0){
            toastr.warning("Este artículo no fue encontrado en almacen, posiblemente el artículo haya sido descontinuado.");
            /* LOGS INICIO */
            var promiseCreateTableLog = new Promise((resolve, reject) => {
                var optionsLog = {
                    pluginId: process.env.NOTIFICACIONES,
                    tableName: 'Logs',
                    request: {
                        "mensaje": "Este artículo no fue encontrado en almacen, posiblemente el artículo haya sido descontinuado."
                    }
                };

                client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                    resolve(result);
                });
            });

            promiseCreateTableLog.then(ctCreate => {

            }, error => {
                console.log(error);
            });
            /* LOGS FIN */
        }
        else {
            toastr.warning("Espere a que las existencias de este artículo carguen o selecciona una dirección válida antes de poder visualizar los almacenes.");
            /* LOGS INICIO */
            var promiseCreateTableLog = new Promise((resolve, reject) => {
                var optionsLog = {
                    pluginId: process.env.NOTIFICACIONES,
                    tableName: 'Logs',
                    request: {
                        "mensaje": "Espere a que las existencias de este artículo carguen o selecciona una dirección válida antes de poder visualizar los almacenes."
                    }
                };

                client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                    resolve(result);
                });
            });

            promiseCreateTableLog.then(ctCreate => {

            }, error => {
                console.log(error);
            });
            /* LOGS FIN */
        }
    }

    renderAvailabilityModalCells(strInputId_I){
        //Get Tag "a" selector custom attribute partCode
        var partCode = $("#a-" + strInputId_I).attr("partcode");
        var objAvailability = this.state.arrAvailabilityParts.find(objPart => objPart.PartCode == partCode);
        let rows = '';
        var extendedAv = [];
        this.state.arrConfiguracionUsuario.forEach(config => {
            if(config != null && config.VisibilidadExtentidaLiderId != null){
                 extendedAv = config.VisibilidadExtentidaLiderId.split(',');
            }
        });
        if(objAvailability != null){
            //Resolve availabilities by partCode
            this.state.arrSucursales.forEach(element => {
                // Just render if extended availability match
                var almacenFound = extendedAv.find(extended => extended == element.LiderId);
                if (
                    almacenFound != null
                    )
                {
                    rows += `<tr key=${element.LiderId} id=${element.LiderId}>
                    <td id=${element.LiderId}>${element.Nombre}</td>
                    <td id="availability">${this.getStockAvailability(element.LiderId, objAvailability.Availabilitys)}</td>
                    </tr>`;
                }
            });
        }

        return rows;
    }

    modalsorting(almacenes, userConfig) {
        if (userConfig.TotalRecords > 0) {
            let myRegion = almacenes.Records.find(x => x.Nombre == userConfig.Records[0].AlmacenFacturacion);

            let almacenesdemiregion = []
            almacenes.Records.forEach(x => {
                if (x.Region == myRegion.Region) {
                    almacenesdemiregion.push(x);
                }
            });

            let almacenesdenomiregion = []
            almacenes.Records.forEach(x => {
                if (x.Region != myRegion.Region) {
                    almacenesdenomiregion.push(x);
                }
            });

            almacenesdemiregion.sort((x, y) => this.NameSortFunction(x, y));
            almacenesdenomiregion.sort((x, y) => this.NameSortFunction(x, y));

            let ordenamiento = almacenesdemiregion.concat(almacenesdenomiregion);

            return ordenamiento;

        } else {
            let ordenamiento = almacenes.Records.sort((x, y) => this.NameSortFunction(x, y));

            return ordenamiento;
        }

    }

    NameSortFunction(x, y) {
        if (x.Nombre > y.Nombre) {
            return 1;
        }
        if (x.Nombre < y.Nombre) {
            return -1;
        }
        // x must be equal to y
        return 0;
    }

    getStockAvailability(depotId, arrAvailabilities) {
        let availability = 0;
        let depot = arrAvailabilities.find(x => x.DepotId == Number(depotId));

        if (depot != undefined && this.hasUserConfig == true) {
            //render just if is in the config table
            if (this.extendAvailability.includes(`${depot.DepotId}`)) {
                availability = depot.Availability;
            }
        }
        else if (depot != undefined && this.hasUserConfig == false) {
            availability = depot.Availability
        } else {
            availability = 0;
        }

        return availability;
    }

    getCookie(name){
        if(typeof window !== 'undefined'){
            var value = '; ' + document.cookie;
            var parts = value.split('; ' + name + '=');
            if (parts.length === 2) {
                return parts.pop().split(';').shift();
            }
        }
    }

    getAddressIdFromCookies(){
        if(typeof window !== 'undefined'){
            //                                                  //To easy code.
            //                                                  //Those values are taken from the widget.
            var addressId = $('#address-name').attr('addressid');
            var depotId  = document.getElementById("address-name").getAttribute("billing-address-lider");
            var branchId = document.getElementById("address-name").getAttribute('billing-address-branch');
            var pedidoInternetId = document.getElementById("address-name").getAttribute('billing-address-pedido');
            this.loadAndSetBillingAddressIdFromAddress(addressId);
            //For testing purposes
            //addressId = 734;
            //depotId = 27505;
            //branchId = 281;
            if(addressId != null && (depotId != null && depotId != "") && (depotId != 'undefined' && depotId != 'undefined') && (branchId && branchId.trim() !== "") && (pedidoInternetId != null)) {
                this.setState({"strCookieAddressId" : addressId})

                //Get availability only if cart is not empty
                if(this.state.cartObject.length > 0){
                    //the state take some time to update his values, set timeout
                    setTimeout(() => {
                        //Lazy Load of availability data/configuration/availability/sale-core-prices
                        context.initAvailabilityInfo();
                        context.initAvailabilityInfoB2C();
                        context.getAvailabilities();
                        //                                             //Ajusta el precio de venta de los productos en el carrito
                        context.getSalePrices();
                        context.checkAllDataFetched();
                    }, 2000)
                }
            }
            else if (this.intLimitRetries == this.intRetries)
            {
                $.unblockUI();
                //var userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";

                var userIsB2C = true;
                if(!this.props.user.Guest) {
                    userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
                }
                if(userIsB2C){
                    try{
                        context.initAvailabilityInfo();
                        context.getAvailabilities();
                        context.initAvailabilityInfoB2C();
                    }catch(e){
                        console.log("TestError",e);
                    }
                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "Informacion obtenida para usuario B2C"
                            }
                        };
                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });
                    this.availabilityItemQtyTotal();
                }else{
                    toastr.error("No se ha podido obtener informacion sobre de los almacenes y sucursales disponibles para su direccion de facturacion. Por favor intente mas tarde o contacte a su ejecutivo de cuenta.");
                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "No se ha podido obtener informacion sobre de los almacenes y sucursales disponibles para su direccion de facturacion. Por favor intente mas tarde o contacte a su ejecutivo de cuenta."
                            }
                        };
                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });
                }
                promiseCreateTableLog.then(ctCreate => {

                }, error => {

                });

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "addressId: ERROR: " + addressId
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {

                });

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "depotId: ERROR: " + depotId
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {
                    console.log(error);
                });

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "branchId: Error: " + branchId
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {
                    console.log(error);
                });

                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "pedidoInternetId: ERROR: " + pedidoInternetId
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {
                    console.log(error);
                });

                /* LOGS FIN */
            }
            else{
                //Recursively calls until address and lider-address is resolved, every 1 seconds if cart is empty.
                if(this.state.cartObject.length > 0){
                    setTimeout(function(){
                        //console.log("Checking address cookie again after 1 second");
                        context.intRetries++;
                        context.getAddressIdFromCookies();
                    }, 1000);
                }
            }
        }
    }

    getSalePrices()
    {
        if(typeof window !== 'undefined'){
            //                                                      // Prepare and Load NumberPart array for all items in cart excluding offers.
            var arrNumberPart = this.arrNumberParts(true);
            let externalUserId =
                this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
            //To test:
            //let externalUserId = {Values:["215"]};
            //This id is taken from the widget.
            var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");
            var pedidoInternetId = document.getElementById("address-name").getAttribute('billing-address-pedido');
            // console.log(pedidoInternetId);
            // Validate type of user for orderTypeCode parameter
            const self = this;
            const userDetail = self.props.user;
            var tipoCliente = 'B2B';
            if(userDetail) {
                if(userDetail.CustomFields) {
                    if(userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario")) {
                        tipoCliente  = userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];
                    }
                }
            }

            if(tipoCliente == "B2C"){
                if(pedidoInternetId == 'undefined') {
                    pedidoInternetId = 'Pedidos Internet'
                }
            }
            //TODO: validate externalUserId and depotId

            //* Este codigo maneja el addressId que envia a Lider
            let addressId = 0;
            if(tipoCliente === "B2B"){
                const billingJson = document.getElementById("billing-addresses")
                    ?.querySelector('option:checked')
                    ?.getAttribute('billing-address-lider');

                if (billingJson) {
                    try {
                        const billingObject = JSON.parse(billingJson);
                        addressId = Number(billingObject.addressID) || 0;
                        console.log('Num 1');
                    } catch (e) {
                        console.error("Error al procesar el JSON de facturación:", e);
                    }
                }
            }

            const priceParams = {
                deptoId: depotId,
                addressId: addressId,
                currencyCode: this.state.currentCurrency,
                customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                detail: arrNumberPart,
                // This value is got from dropwodn list who list the order types allowed by the order.
                orderTypeCode: tipoCliente === "B2C" ? pedidoInternetId : document.getElementById("select-order-type").value
            };

            const nonOfferPromise = arrNumberPart.length > 0 ? client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams) : null;

            //                                                      // Prepare and Load NumberPart array for all items in cart whos are offers.
            //* Este sirve para los productos en el carrito que traen precios del Lider
            var arrOfferNumberPart = this.arrOfferNumberParts();
            const priceOfferParams = {
                deptoId: depotId,
                addressId: addressId,
                currencyCode: this.state.currentCurrency,
                customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                detail: arrOfferNumberPart,
                orderTypeCode: tipoCliente === "B2C" ? pedidoInternetId : "NORMAL"
            };

            const offerPromise = arrOfferNumberPart.length > 0 ? client.BepensaPrices.getBepensaPricesByPartNumbers(priceOfferParams) : null;

            Promise.all([nonOfferPromise, offerPromise]).then(response => {
                var arrSaleAndCorePrices = [];
                var boolFailedNonOffers = false;
                var boolFailedOffers = false;

                /* LOGS INICIO */
                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": response[0]
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {
                    console.log(error);
                });
                /* LOGS FIN */

                if (
                    response[0] != null &&
                    response[0].Result != undefined && response[0].Result == 0 &&
                    response[0].PartsCode != undefined && response[0].PartsCode.length > 0
                    )
                {
                    response[0].PartsCode.forEach(function(part, index){
                        if (
                            part.PartsPrices != null && part.PartsPrices.length > 0
                            )
                        {
                            var partNumber = part.PartCode;
                            var salePrice = null;
                            var corePrice = null;
                            if(part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null){
                                salePrice = part.PartsPrices[0].SalePrice;
                                if(part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null){
                                    corePrice = part.PartsPrices[0].CorePart.SalePrice
                                }
                            }

                            /* LOGS INICIO */
                            var promiseCreateTableLog = new Promise((resolve, reject) => {
                                var optionsLog = {
                                    pluginId: process.env.NOTIFICACIONES,
                                    tableName: 'Logs',
                                    request: {
                                        "mensaje": "partNumber: " + partNumber + " salePrice: " + salePrice + " corePrice: " + corePrice
                                    }
                                };

                                client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                                    resolve(result);
                                });
                            });

                            promiseCreateTableLog.then(ctCreate => {

                            }, error => {
                                console.log(error);
                            });
                            /* LOGS FIN */

                            arrSaleAndCorePrices.push({
                                partNumber : partNumber,
                                salePrice : salePrice,
                                corePrice : corePrice
                            });
                        }
                    });
                }else{
                    //Rise flag when response[0] request failed
                    boolFailedNonOffers = true;
                }


                /* LOGS INICIO */
                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": response[1]
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {
                    console.log(error);
                });
                /* LOGS FIN */

                if (
                    response[1] != null &&
                    response[1].Result != undefined && response[1].Result == 0 &&
                    response[1].PartsCode != undefined && response[1].PartsCode.length > 0
                    )
                {
                    response[1].PartsCode.forEach(function(part, index){
                        if (
                            part.PartsPrices != null && part.PartsPrices.length > 0
                            )
                        {
                            var partNumber = part.PartCode;
                            var salePrice = null;
                            var corePrice = null;
                            if(part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null){
                                salePrice = part.PartsPrices[0].SalePrice;
                                if(part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null){
                                    corePrice = part.PartsPrices[0].CorePart.SalePrice
                                }
                            }

                            /* LOGS INICIO */
                            var promiseCreateTableLog = new Promise((resolve, reject) => {
                                var optionsLog = {
                                    pluginId: process.env.NOTIFICACIONES,
                                    tableName: 'Logs',
                                    request: {
                                        "mensaje": "partNumber: " + partNumber + " salePrice: " + salePrice + " corePrice: " + corePrice
                                    }
                                };

                                client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                                    resolve(result);
                                });
                            });

                            promiseCreateTableLog.then(ctCreate => {

                            }, error => {
                                console.log(error);
                            });
                            /* LOGS FIN */

                            arrSaleAndCorePrices.push({
                                partNumber : partNumber,
                                salePrice : salePrice,
                                corePrice : corePrice
                            });
                        }
                    });
                }else{
                    //Rise flag when response[1] request failed
                    boolFailedOffers = true;
                }

                if(boolFailedOffers && boolFailedNonOffers){
                    $.unblockUI();
                    toastr.warning("No se pudieron obtener los precios de estos artículos, contacte al administrador del sitio");
                    //Si esto pasa los precios no se actualizaron, por lo que se debe recargar la página.
                    //window.location.href = 'https://' + process.env.BASE_URL;

                    this.props.cartPageModel.cartList.forEach(function(cartModel, i){
                        cartModel.forEach(function(cart, j){
                            cart.ItemDetail['boolPriceChanged'] = false;
                        });
                    });
                }
                else
                {
                    //                                                              //Update prices, for those who were loaded
                    context.subUpdateCartModelPricesProperties(arrSaleAndCorePrices);
                }
            }).catch(error => {
                //TODO: Handle error                                                //alguno de las promesas falló
                //                                                                  //si se requiere ajustar precio no se tendría
                $.unblockUI();
                toastr.warning("No se pudieron obtener los precios de estos artículos, contacte al administrador del sitio");
                console.log(error);

                /* LOGS INICIO */
                var promiseCreateTableLog = new Promise((resolve, reject) => {
                    var optionsLog = {
                        pluginId: process.env.NOTIFICACIONES,
                        tableName: 'Logs',
                        request: {
                            "mensaje": "Bandera boolPriceChanged: false."
                        }
                    };

                    client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                        resolve(result);
                    });
                });

                promiseCreateTableLog.then(ctCreate => {

                }, error => {
                    console.log(error);
                });
                /* LOGS FIN */

                this.props.cartPageModel.cartList.forEach(function(cartModel, i){
                    cartModel.forEach(function(cart, j){
                        cart.ItemDetail['boolPriceChanged'] = false;
                    });
                });
                //window.location.href = 'https://' + process.env.BASE_URL;
            });
        }
    }

    subUpdateCartModelPricesProperties(
        arrSaleAndCorePrices_I
    )
    {
        //This variable is used to decide if reload amounts or not depending of arrSaleAndCorePrices_I.
        let boolReloadTotals = false;
        var cartObject = [];

        if(arrSaleAndCorePrices_I.length <= 0){
            toastr.warning("No se pudieron obtener los precios de estos artículos, inténtelo más tarde");
            //No debio llegar aqui con la lista de precios vacia
            throw new Error("No se pudieron obtener los precios de estos artículos, inténtelo más tarde");
        }

        //If item match with property update sale and core files
        this.props.cartPageModel.cartList.forEach(function(cartModel, i){
            cartModel.forEach(function(cart, j){
                var itemPartNumber = null;
                var cfPartNumberIndex = -1;
                let originalPrice = cart.ItemDetail.Price;
                let originalCurrency = null;
                let originalCorePrice = "0.00";
                if(cart.ItemDetail.CustomFields != null){
                    cfPartNumberIndex = cart.ItemDetail.CustomFields.findIndex(cf => cf.Name == "Número de Parte");
                    if(cfPartNumberIndex >= 0){
                        itemPartNumber = cart.ItemDetail.CustomFields[cfPartNumberIndex].Values[0];
                    }

                    let cfOriginalCurrency = cart.ItemDetail.CustomFields.findIndex(cf => cf.Name == "Currency");
                    if(cfOriginalCurrency >= 0){
                        originalCurrency = cart.ItemDetail.CustomFields[cfOriginalCurrency].Values[0];
                    }

                    let cfCorePrice = cart.ItemDetail.CustomFields.findIndex(cf => cf.Name == "Precio Core");
                    if (
                        cfCorePrice >= 0
                        )
                    {
                        if (
                            cart.ItemDetail.CustomFields[cfCorePrice].Values[0] != ""
                            )
                        {
                            originalCorePrice = cart.ItemDetail.CustomFields[cfCorePrice].Values[0];
                        }
                    }
                }

                if(itemPartNumber != null){
                    var partObject = arrSaleAndCorePrices_I.find(part => part.partNumber == itemPartNumber);
                    if (
                        partObject != null
                        )
                    {
                        boolReloadTotals = true;

                        // Match found, update if sale and core are not null.
                        if (
                            partObject.salePrice != null
                            )
                        {
                            //Update sale price                           //Aqui es donde se pone el precio de venta en PESOS
                            cart.ItemDetail.Price = partObject.salePrice;
                            cart.ItemDetail['boolPriceChanged'] = true;
                        }

                        /* LOGS INICIO */
                        var promiseCreateTableLog = new Promise((resolve, reject) => {
                            var optionsLog = {
                                pluginId: process.env.NOTIFICACIONES,
                                tableName: 'Logs',
                                request: {
                                    "mensaje": "itemPartNumber: " + itemPartNumber + " salePrice: " + partObject.salePrice + " boolPriceChanged: " + cart.ItemDetail['boolPriceChanged']
                                }
                            };

                            client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                                resolve(result);
                            });
                        });

                        promiseCreateTableLog.then(ctCreate => {

                        }, error => {
                            console.log(error);
                        });
                    } else {
                        //                              //Aunque tenemos resultados, no se encuentra el item en el arreglo de precios
                        /* LOGS INICIO */
                        var promiseCreateTableLog = new Promise((resolve, reject) => {
                            var optionsLog = {
                                pluginId: process.env.NOTIFICACIONES,
                                tableName: 'Logs',
                                request: {
                                    "mensaje": "No se encontró precio de un artículo, inténtelo más tarde " + partObject
                                }
                            };

                            client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                                resolve(result);
                            });
                        });

                        promiseCreateTableLog.then(ctCreate => {

                        }, error => {
                            console.log(error);
                        });
                        /* LOGS FIN */

                            $.unblockUI();
                            toastr.warning("No se encontró precio de un artículo, inténtelo más tarde");
                            console.log(error);
                            throw new Error("No se encontró precio de un artículo, inténtelo más tarde");
                    }
                }

                var cartItemState = {
                    CartId: cart.ID,
                    CartQty: cart.Quantity,
                    ItemDetail: cart.ItemDetail,
                    OriginalPrice : originalPrice,
                    OriginalCurrency : originalCurrency,
                    OriginalCorePrice : originalCorePrice
                };

                cartObject.push(cartItemState);
            });
        });

        if (
            boolReloadTotals
            )
        {
            this.setState({"cartObject": cartObject}, () => {
                this.totalOrderCalculated = this.numRecalculateTotalFromCartObject(cartObject, 0);
                this.setState({"boolSalePriceWasLoaded":true});
                this.totalItemPriceCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 1);
                this.setState({"numItemPriceTotal":this.totalItemPriceCalculated});
                this.totalItemCorePriceCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 2);
                this.setState({"numItemCoreTotal":this.totalItemCorePriceCalculated});
                this.setState({"numTotalOrder":this.totalOrderCalculated}, () => {
                    $.unblockUI();
                    toastr.success("Precios actualizados con éxito...");

                    /* LOGS INICIO */
                    var promiseCreateTableLog = new Promise((resolve, reject) => {
                        var optionsLog = {
                            pluginId: process.env.NOTIFICACIONES,
                            tableName: 'Logs',
                            request: {
                                "mensaje": "Recalculando precios"
                            }
                        };

                        client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                            resolve(result);
                        });
                    });

                    promiseCreateTableLog.then(ctCreate => {

                    }, error => {
                        console.log(error);
                    });
                    /* LOGS FIN */

                    this.props.cartPageModel.cartList.forEach(function(cartModel, i){
                        cartModel.forEach(function(cart, j){
                            cart.ItemDetail['boolPriceChanged'] = true;
                        });
                    });
                });
            });
        } else {
            $.unblockUI();
            toastr.success("Precios actualizados con éxito...");
        }
    }

    numRecalculateTotalFromCartObject(
        cartObject_I,
        // intCalculationType values: 0 = itemPrice + coreTotal, 1 = itemPrice only, 2 = coreTotal only
        intCalculationType_I = 0
    )
    {
        let numTotalPrice = 0;
        let self = this;
        cartObject_I.forEach(function(cartItem, index){
            var corePriceCF = cartItem.ItemDetail.CustomFields.find(cf => cf.Name == "Precio Core");
            var corePrice = 0.0;
            var itemPriceDefault = cartItem.ItemDetail.Price;
            if(corePriceCF != null){
                if(corePriceCF.Values[0].length > 0){
                    corePrice = parseFloat(corePriceCF.Values[0]);
                }
            }
            let currencyCodeCf = cartItem.ItemDetail.CustomFields.find(x => x.Name == "Currency");
            let strCurrencyCode = "";
            if (currencyCodeCf != undefined || currencyCodeCf != null) {
                if(currencyCodeCf.Values[0].length > 0){
                    strCurrencyCode = currencyCodeCf.Values[0];
                }
            }
            //All prices in MXN at first
            if (
                strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                self.state.currentCurrency == "MXN" && (cartItem.ItemDetail.boolPriceChanged == undefined || cartItem.ItemDetail.boolPriceChanged == false)
                )
            {
                itemPriceDefault = itemPriceDefault * parseFloat(self.state.currentExchange);
            }

            if (
                strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                self.state.currentCurrency == "MXN"
                )
            {
                corePrice = corePrice * parseFloat(self.state.currentExchange);
            }

            switch (intCalculationType_I) {
                case 0:
                    numTotalPrice += self.numCalculateSubTotal(cartItem.CartQty, itemPriceDefault, corePrice);
                    break;
                case 1:
                    numTotalPrice += self.numCalculateSubTotal(cartItem.CartQty, itemPriceDefault, 0);
                    break;
                case 2:
                    numTotalPrice += self.numCalculateSubTotal(cartItem.CartQty, 0, corePrice);
                    break;
            }
        });

        return numTotalPrice;
    }

    subSetOptionAddressSelected()
    {
        //Getting selected addressId if exist
        var strSelectedAddress = "";
        if(this.state != null && this.state.strCookieAddressId != null && this.state.strCookieAddressId != ""){
            strSelectedAddress = this.state.strCookieAddressId;
        }else {
            var addressAtt = $('#address-name').attr('addressid');
            if(addressAtt != null && addressAtt != ""){
                strSelectedAddress = addressAtt;
            }
        }

        var arrOptions = $("#shipping-addresses").children();
        if (
            arrOptions.length > 0
            )
        {
            for (let index = 0; index < arrOptions.length; index++) {
                var option = arrOptions[index];
                if (
                    $(option).attr('id') == strSelectedAddress
                    )
                {
                    $(option).attr('value', "true");
                }
                else
                {
                    $(option).removeAttr('value');
                }
            }
        }
    }

    getAvailabilities(){
        var arrPartCodes = this.arrNumberParts();
        const requestBody = {
            "operatingUnitId": 446,
            "partsCode": arrPartCodes
        };

        //console.log("partCodes");
        client.Availability.GetAvalability(requestBody).then((response) => {
            /* LOGS INICIO */
            var promiseCreateTableLog = new Promise((resolve, reject) => {
                var optionsLog = {
                    pluginId: process.env.NOTIFICACIONES,
                    tableName: 'Logs',
                    request: {
                        "mensaje": "Availability: " + response
                    }
                };

                client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                    resolve(result);
                });
            });

            promiseCreateTableLog.then(ctCreate => {

            }, error => {

            });
            /* LOGS FIN */

            if(response != null && response.Result == 0){
                if(response.Parts != null && response.Parts.length > 0){
                    context.setState({"arrAvailabilityParts":response.Parts});
                    let totalAvailability = 0;
                    this.state.arrAvailabilityParts[0].Availabilitys.forEach((availability) => {
                        totalAvailability += availability.Availability;
                    });
                    context.setState({"totalAvailabilityParts":totalAvailability});
                }
            }else{
                context.boolAvailabilityPromiseFailed = true;
                toastr.error("Se ha producido un error al obtener las existencias de estos números de parte.");
            }
        });
    }

    arrNumberParts(
        boolExcludeOffers_I = false
    )
    {
        var arrPartCodes = [];
        this.state.cartObject.forEach(function(cartItem, index){
            if(cartItem.ItemDetail.CustomFields != null){
                var boolExcluded = false;
                if(boolExcludeOffers_I){
                    boolExcluded = context.boolIsItemOffer(cartItem.ItemDetail);
                }
                var numberPart = cartItem.ItemDetail.CustomFields.find(cf => cf.Name == "Número de Parte")
                if(numberPart != null && !boolExcluded){
                    arrPartCodes.push({"partCode":numberPart.Values[0]})
                }
            }
        });

        return arrPartCodes;
    }

    arrOfferNumberParts(){
        var arrPartCodes = [];
        this.state.cartObject.forEach(function(cartItem, index){
            if(cartItem.ItemDetail.CustomFields != null){
                var boolIsOffert = context.boolIsItemOffer(cartItem.ItemDetail);
                if(boolIsOffert){
                    var numberPart = cartItem.ItemDetail.CustomFields.find(cf => cf.Name == "Número de Parte")
                    if(numberPart != null){
                        arrPartCodes.push({"partCode":numberPart.Values[0]})
                    }
                }
            }
        });

        return arrPartCodes;
    }

    boolIsItemOffer(
        itemDetails_I
    )
    {
        let offerCategory = itemDetails_I.Categories != null ? itemDetails_I.Categories.find(cat => cat.Name == "Ofertas") : null;
        return offerCategory != null ? true : false;
    }

    addressChanged(){
        //var addressId = this.getCookie('SelectedAddress');
        var addressId = $('#address-name').attr('addressid');
        //console.log("recursive addressId: " + addressId);
        if(addressId != this.state.strCookieAddressId){
            //console.log("addressId changed: " + addressId);

            //Reload availability
            let self = this;
            this.setState({arrAlmacenes: []});
            this.setState({arrConfiguracionUsuario: []});
            this.setState({arrAvailabilityParts: []});
            this.setState({"strCookieAddressId":addressId}, () => {
                $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Recalculando precios y existencias, por favor espere...' });
                console.log("saved state");
                //Reload selected Address widget
                self.subSetOptionAddressSelected();

                //Lazy Load of availability data/configuration/availability
                self.initAvailabilityInfo();
                self.getAvailabilities();
                self.checkAllDataFetched();
                self.initAvailabilityInfoB2C();
                //Reload Occur freights
                self.getOccurAddresses();
            });
        }
        else{
            //Recursive method called every 1 second
            setTimeout(() => {
                this.addressChanged();
                this.loadSalePrices();
            }, 1000 )
        }
    }

    loadSalePrices() {
        if(typeof window !== 'undefined'){
            //                                                  //This id is taken from the widget.
            var depotId = document.getElementById("address-name").getAttribute("billing-address-lider");

            if (this.props.user.Guest == false && (depotId != null && depotId != "")) {
                var self = this;
                let userType = this?.props?.user?.CustomFields != null ? this?.props?.user?.CustomFields.find(cf => cf.Name == "Tipo de Usuario")?.Values[0] : null;
                let externalUserId =
                    this.props.user.CustomFields != null ? this.props.user.CustomFields.find(cf => cf.Name == "Cliente ID") : null
                //To test: 
                //let externalUserId = {Values:["215"]};

                var arrOfParts = [];

                for(var i = 0; i < document.getElementsByClassName('item-name').length; i++){
                    if(i % 2 ==  0) {
                        arrOfParts.push({ "partCode": document.getElementsByClassName('item-name')[i].innerText});
                    }
                }

                const priceParams = {
                    deptoId: depotId,
                    //MXN currency by default
                    currencyCode: "MXN",
                    customerId: externalUserId != null ? externalUserId.Values[0] : "0",
                    //by default order type is Offer AKA Normal
                    orderTypeCode: userType != null && userType === "B2C" ? "PEDIDOS INTERNET" : "NORMAL",
                    detail: arrOfParts
                };

                client.BepensaPrices.getBepensaPricesByPartNumbers(priceParams).then(response => {
                    if (
                        response.Result != undefined && response.Result == 0 &&
                        response.PartsCode != undefined && response.PartsCode.length > 0
                    ) {
                        response.PartsCode.forEach(function (part, index) {

                            var partNumber = part.PartCode;
                            var salePrice = null;
                            var corePrice = null;
                            if (part.PartsPrices != null && part.PartsPrices[0] != null && part.PartsPrices[0].SalePrice != null) {
                                document.getElementById('precioPublico' + partNumber).innerHTML = `<b>$ ${self.subFormatMoney(part.PartsPrices[0].PublicPrice)} MXN</b>`;
                                
                                if(userType != 'B2C') {
                                    if(part.PartsPrices[0].PublicPrice != part.PartsPrices[0].SalePrice) {
                                        document.getElementById('precioPublico' + partNumber).setAttribute('style', 'text-decoration: line-through;color: red !important;');
                                        document.getElementById('precioDescuento' + partNumber).innerHTML = ` <b>$ ${self.subFormatMoney(part.PartsPrices[0].SalePrice)} MXN</b>`;
                                    }
                                }
                                /*
                                salePrice = part.PartsPrices[0].SalePrice;
                                if (part.PartsPrices[0].CorePart != null && part.PartsPrices[0].CorePart.SalePrice != null) {
                                    corePrice = part.PartsPrices[0].CorePart.SalePrice
                                }

                                //If match with any item in state.arrOffers update his value
                                let indexOf = -1;
                                self.state.arrOffers.forEach((item, index) => {
                                    if (item.strNumberPart == partNumber) {
                                        indexOf = index;
                                    }
                                });
                                if (indexOf >= 0) {
                                    self.state.arrOffers[indexOf].boolIsOverridenPrice = salePrice != null ? true : false;
                                    self.state.arrOffers[indexOf].boolIsOverridenCore = corePrice != null ? true : false;
                                    self.state.arrOffers[indexOf].SalePrice = salePrice || "";
                                    self.state.arrOffers[indexOf].SaleCorePrice = corePrice || "";
                                }
                                */
                            }
                        });
                    }
                });
            }else {
                //                                              //If not loaded yet billing-address-lider try again on the
                //                                              //      next second.
                setTimeout(() => {
                    this.loadSalePrices();
                }, 1000);
            }
        }
    }

    checkAllDataFetched(){
        //Check every second to see if everything is got, before to render the view
        if (
            this.state.arrAlmacenes.length > 0 &&
            this.state.arrConfiguracionUsuario.length > 0 &&
            this.state.arrAvailabilityParts.length > 0
            )
        {
            this.renderAvailabilityParts();

            //Store extended availability.
            this.extendAvailability = this.state.objConfigurationResponse.Records[0].VisibilidadExtentidaLiderId.split(',');

            //At this point arrConfiguracionUsuario has values, so.
            this.hasUserConfig = true;

            //Populate arrSucursales with the information which we received
            var sucursales = this.modalsorting(this.state.objAlmacenesResponse, this.state.objConfigurationResponse);
            if(sucursales.length > 0 ){
                this.setState({"arrSucursales":sucursales});
            }

            //Init recursive method to detect when address changed
            $.unblockUI();
            this.addressChanged();
        }
        else if (
            this.boolAvailabilityPromiseFailed || this.boolConfigAvailabilityPromiseFailed ||
            this.boolBranchesPromiseFailed
            )
        {
            $.unblockUI();
            toastr.error("Se han detectado errores al calcular existencias y precios, por favor contacte al administrador del sitio");

            this.props.cartPageModel.cartList.forEach(function(cartModel, i){
                cartModel.forEach(function(cart, j){
                    cart.ItemDetail['boolPriceChanged'] = false;
                });
            });
        }
        else{
            setTimeout(function(){
                context.checkAllDataFetched();
            }, 1000)
        }
    }

    renderAvailabilityParts(){
        this.state.cartObject.forEach(function(cartItem, i){
            //Get Number Part CF
            var item = cartItem.ItemDetail;
            var numberPartCF = null;
            if(item.CustomFields != null){
                numberPartCF = item.CustomFields.find(cf => cf.Name == "Número de Parte");
            }

            var numberPart = "";
            if(numberPartCF != null){
                if(numberPartCF.Values[0].length > 0){
                    numberPart = numberPartCF.Values[0];
                }
            }
            if(numberPart != ""){
                var availabilityPart = context.state.arrAvailabilityParts.find(avPart => avPart.PartCode == numberPart);
                if(availabilityPart != null){
                    //Calculate availability
                    var numAv = 0;
                    context.state.arrConfiguracionUsuario.forEach(function(configAlm, k){
                        var arrDepots = configAlm.VisibilidadExistenciasLiderId.split(',');
                        arrDepots.forEach(function(depot, l){
                            var availabilityObject = availabilityPart.Availabilitys.find(avs => avs.DepotId == parseInt(depot));
                            if(availabilityObject != null){
                                numAv += availabilityObject.Availability;
                            }
                        });
                    });
                    // console.log("Total de existencias: " + numAv);
                    if(context.state.userIsB2C){
                        //$("#a-" + item.ID).text(numAv);
                    }else{
                        $("#a-" + item.ID).text(numAv);
                    }
                }
                else{

                }
            }
        });
    }

    initAvailabilityInfo(){
        var userIsB2C = true;
        if(!this.props.user.Guest) {
            userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
        }
        //var userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";

        var optionsAlm = {
            pluginId: this.packageIdAlmacenes,
            tableName: "Almacenes",
            query: [
                {
                    Name: 'IsActive',
                    Operator: "eq",
                    Value: "true"
                }
            ]
        };

        client.CustomTables.searchCustomTable(optionsAlm, function (err, result) {
            if(err == null){
                context.setState({"objAlmacenesResponse":result});
                context.setState({"arrAlmacenes":result.Records});
            }else{
                context.boolBranchesPromiseFailed = true;
                toastr.error("Se ha producido un error al obtener las existencias de estos números de parte.");
            }
        });

        if (userIsB2C){
            context.setState({userIsB2C: true});
            var optionsCU = {
                pluginId: this.packageIdAlmacenes,
                tableName: "ConfiguracionUsuario",
                query: [ ]
            };
        }else{
            var optionsCU = {
                pluginId: this.packageIdAlmacenes,
                tableName: "ConfiguracionUsuario",
                query: [
                    {
                        Name: "UserId",
                        Operator: "equal",
                        Value: this.props.user.ID
                    },
                    {
                        Name: "AddressId",
                        Operator: "equal",
                        Value: this.state.strCookieAddressId
                    }
                ]
            };
        }

        client.CustomTables.searchCustomTable(optionsCU, function (err, result) {
            if(err == null){
                context.setState({"objConfigurationResponse":result});
                if(result.Records.length > 0){
                    context.setState({"arrConfiguracionUsuario":result.Records});
                }else{
                    context.boolConfigAvailabilityPromiseFailed = true;
                    toastr.warning("Tu dirección actual no cuenta con definición de almacenes, por favor comunícate con tu proveedor.");
                }
            }else{
                context.boolConfigAvailabilityPromiseFailed = true;
                toastr.error("Se ha producido un error al obtener las existencias de estos números de parte.");
            }
        });
    }

    getShippingMethods(){
        //Take one cart item id and get merchant id from it.
        if(this.state.cartObject.length > 0){
            client.ShippingMethods.getShippingMethods(this.state.merchantId, function(err, shipM){
                context.setState({"arrShipmentMethods":shipM});
                context.renderShipmentOptions();
            });
        }
    }

    renderShipmentOptions(){
        var selectShipping = $("#shipping-methods");
        this.state.arrShipmentMethods.forEach(function(shipM, index){
            if (index == 0 && shipM.Description == "Envío Terrestre - Entrega a domicilio") {
                context.setState({boolHideShippingDiv:false});
            }

            var jsonCustomFields = shipM.CustomFields[0].Values;
            var customFields = JSON.parse(jsonCustomFields);
            var calculationType = customFields.CalculationType;
            var rates = JSON.stringify(customFields.Rates);
            let isB2C = context.isThisUserB2C();
            // console.log(isB2C);

            // Skipping ocurre shipping if user is not B2C
            if(isB2C && shipM.ID == "b031c55d-f310-4728-b6ec-120d1a889cc7"){
                return;
            }

            if(shipM.ID == "84a598f3-33b9-4911-a329-523c4db33dc9"){
                selectShipping.append('<option id=' + shipM.ID + ' data-calculation-type=' + calculationType + ' data-rates=' + rates + ' selected>' + shipM.Description + '</option>');
            }else{
                selectShipping.append('<option id=' + shipM.ID + ' data-calculation-type=' + calculationType + ' data-rates=' + rates + '>' + shipM.Description + '</option>');
            }

            // I commented out these next two lines because they block the rendering of shipping methods in the cart.
            //let selectShipping = document.getElementById("shipping-addresses");
            //selectShipping.disabled = false;
        });
        this.getCalculationType();
    }

	isThisUserB2C(){
        //var userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
        var userIsB2C = true;
        if(!this.props.user.Guest) {
            userIsB2C = this.props.user.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0] === "B2C";
        }
		return userIsB2C;
	}

    getCalculationType(){
        var calculationType = $('#shipping-methods').find(':selected').attr('data-calculation-type');
        var jsonRates = $('#shipping-methods').find(':selected').attr('data-rates');
        var rates = JSON.parse(jsonRates);
        this.setState({"shippingDataCalculation":calculationType});
        this.setState({"shippingRates":rates});
    }

    getUserAddresses(){
        var self = this;
        client.Addresses.getUserAddresses(this.props.user.ID, function(err, addresses){
            if (
                addresses != null && addresses.Records != null && addresses.Records.length > 0
                )
            {
                self.setState({"arrAddresses" : addresses.Records});
                self.renderAddressesOptions();
                //Set in the UI the shipping method selected by widget
                context.subSetOptionAddressSelected();
            }
        });
    }

    renderAddressesOptions(){
        var selectShipping = $("#shipping-addresses");
        selectShipping.empty();
        this.state.arrAddresses.forEach(function(address, index){
            // console.log(address);
            //Pickup is used as a flag for shipment address
            if(address.Pickup){
                let addressName = address.Line2 || address.Name;
                selectShipping.append(
                    '<option id=' + address.ID + '>' + addressName + '</option>'
                );
            }
        });
    }

    handleAddressChange(e){
        const selectElement = e.target; 
        const selectedOptionId = selectElement.options[selectElement.selectedIndex].id;
        const selectedAddress = this.state.arrAddresses.find(address => address.ID === selectedOptionId);
        if (selectedAddress) {
            this.subGetBillingAddress(selectedAddress.ID);
            this.setState({ shippingAddress: selectedAddress });
        }
    } 

    componentDidUpdate() {
        let self = this;
        $(".openModalRemove").on("click", function () {
            var $parent = $(this).parents(".parent-r-b");
            $parent.addClass("modal-delete-open");
            $("#modalRemove").modal("show");
            let cartId = $(this).attr("id");
            self.props.deleteSelectCartId(cartId);
        });
        $("#modalRemove .btn-gray").on("click", function (e) {
            $(".parent-r-b").removeClass("modal-delete-open");
            e.stopImmediatePropagation();
            $("#modalRemove").modal("hide");
            self.props.deleteSelectCartId("");
        });
        $("#modalRemove #btnRemove").on("click", function (e) {
            $("#modalRemove").modal("hide");
         //   $(".parent-r-b.modal-delete-open").remove();
            e.stopImmediatePropagation();
            self.props.deleteCartItem(self.props.cartPageModel.cartItemToDelete, self.props.user.ID);
        });

        $(".cart-edit").on("click", function (e) {
            let cartId = $(this).attr("id");
            e.stopImmediatePropagation();
            self.props.editCartItem(cartId);
            $("#cartItemEdit").modal("show");
        });

        let guestUserID = "";
        if (CommonModule.getCookie("guestUserID") && CommonModule.getCookie("guestUserID") !== "") {
            guestUserID = CommonModule.getCookie("guestUserID");
            if (guestUserID !== this.props.user.ID) {
                guestUserID = "";
            }
        }
        const options = {
            pageSize: 1000,
            pageNumber: 1,
            includes: null,
            guestUserID: guestUserID
        }

        if (
            //This code is to avoid call getCartUser endpont everytime the component update.
            !this.componenCartDidUpdate
            )
        {
            self.props.getUserCarts(options, null);
            this.componenCartDidUpdate = true;
        }
    }

    renderVariants(itemDetail) {
        const { locationVariantGroupId } = this.props;

        if (itemDetail && itemDetail.Variants) {
            let el = [];
            itemDetail.Variants.forEach(function (variant, i) {
                if (variant.GroupID != locationVariantGroupId) {
                    el.push(
                        <span key={i} className="if-txt">
                            <span>{variant.GroupName}:</span>
                            <span>{variant.Name}</span>
                        </span>
                    );
                }
            });
            return el;
        }
    }

    renderItemInfo(item) {
        const itemImageUrl = item.Media && item.Media.length > 0 ? item.Media[0].MediaUrl : '';
        if (item && item.Variants && item.Variants.length > 0) {
            return (
                <div className="flex-wrap">
                    <div className="thumb-group">
                        <img alt="" data-src={itemImageUrl} className="lazyload" />
                    </div>
                    <div>
                        <span>
                            {item.Name}
                            <div className="item-field">
                                {this.renderVariants(item)}
                            </div>
                        </span>
                    </div>
                </div>
            );
        }
        return (
            <div className="thumb-group">
                <img alt="" data-src={itemImageUrl} className="lazyload" />
                <span> {item.Name} </span>
            </div>
        )
    }

    updateItemQuantity(strInputId_I,strDeltaType_I) {
        var input = $("#ipt-" + strInputId_I);
        let salesUnit = this.getUnidadVenta(strInputId_I);
        salesUnit = parseInt(salesUnit);
        var intInputValue = 0;
        var intValueUnit = 0;
        var isByControl = false;
        if (!isNaN(input.val())) {
            intInputValue = parseInt(input.val());
        }
        if (intInputValue == 0) {
            intValueUnit = salesUnit;
        }
        else if (intInputValue > 0) {
            if (this.boolIsMultiple(input.val(), salesUnit)) {
                intValueUnit = salesUnit;
            } else {
                if (intInputValue < salesUnit) {
                    intInputValue = 0;
                    if (strDeltaType_I == "plus") {
                        intValueUnit = salesUnit;
                    } else {
                        intValueUnit = salesUnit;
                    }
                } else {
                    // Arrays que contendran los valores multiples de salesUnit
                    let multiples_salesUnit = [];
                    var aux = input.val() * salesUnit;
                    for (var i = 1; i <= aux; i++) {
                        if (this.boolIsMultiple(i, salesUnit)) {
                                multiples_salesUnit.push(i);
                        };
                        if(multiples_salesUnit){
                            for (let index = 0; index < multiples_salesUnit.length; index++) {
                                const element = multiples_salesUnit[index];
                                if (input.val() < element) {
                                    intInputValue = 0;
                                    intValueUnit = element;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
        }
        if (strDeltaType_I == "plus") {
            intInputValue += intValueUnit;
        }
        else if (strDeltaType_I == "minus") {
            if((intInputValue == salesUnit) &&  (salesUnit > 1)){
                intInputValue = salesUnit;
                isByControl = true;

            } else{
                intInputValue -= intValueUnit;
            }
        }
        var boolItemsAvailableB2C= this.boolExistAvailability(strInputId_I, intInputValue);
        if(this.state.userIsB2C && !boolItemsAvailableB2C){
            toastr.error("No hay existencias suficientes para este artículo");
        }
        let boolIsAntecesor = this.boolIsAntecesor(strInputId_I);
        //Update UI, not allowed negative values
        if (intInputValue > 0) {
            if ((intInputValue > 1) && (isByControl == true)) {
                this.showDeleteItemModalConfimationUnit(strInputId_I);
            }
            else  if (this.boolAvailabilityCheckDisabled || this.boolExistAvailability(strInputId_I, intInputValue)) {
                if(this.state.userIsB2C){
                    if(boolItemsAvailableB2C){
                        this.updateItemFromCart(strInputId_I, intInputValue, input);
                    }else{
                        input.val(parseInt(salesUnit));
                    }
                }else{
                    this.updateItemFromCart(strInputId_I, intInputValue, input);
                }
            }
            else if (!boolIsAntecesor) {
                //Ask if user want to add an item even if doing it will cause backorder records.
                this.subOpenAvailabilityDisabledModal(strInputId_I, strDeltaType_I);
            }
            else if (boolIsAntecesor)
            {
                toastr.info("Este número de parte es un Antecesor, al no contar con existencias suficientes, no podemos actualizar la cantidad especificada");
            }
        }

        else if (
            (intInputValue <= 0) && (isByControl == false)
        ) {
            this.showDeleteItemModalConfimation(strInputId_I);
        }
     }

    boolIsMultiple(quantity, unit) {
        var boolIsMultiple = false;
        var resto = quantity % unit;

        if (resto == 0) {
            boolIsMultiple = true;
        } else {
            boolIsMultiple = false;
        }
        return boolIsMultiple;
    }

    getUnidadVenta(strInputId_I) {
        let unidadVentaValue = 1;
        let cartObject = this.resolveItemCartObject(strInputId_I);
        if (
            cartObject != null
        ) {
            //                                              //Check for Unidad de venta CF.
            let item = cartObject.ItemDetail;
            if (
                item.CustomFields != null
            ) {
                let unidadVentaCF = item.CustomFields.find(cf => cf.Code == process.env.CF_SALES_UNIT);
                if (
                    unidadVentaCF != null
                ) {
                    unidadVentaValue = unidadVentaCF.Values[0];
                }
            }
        }
        return unidadVentaValue;
    }

    boolIsAntecesor(
        strInputId_I
    )
    {
        let boolIsAntecesor = false;
        let cartObject = this.resolveItemCartObject(strInputId_I);
        if (
            cartObject != null
            )
        {
            //                                              //Check for Supercesor and Numero de parte CF.
            let item = cartObject.ItemDetail;
            if (
                item.CustomFields != null
                )
            {
                let supercesorCF = item.CustomFields.find(cf => cf.Name == "Supercesor");
                let numeroParteCF = item.CustomFields.find(cf => cf.Name == "Número de Parte");
                if (
                    supercesorCF != null && numeroParteCF != null
                    )
                {
                    let supercesorValue = supercesorCF.Values[0];
                    let numeroParteValue = numeroParteCF.Values[0];
                    if (
                        supercesorValue != numeroParteValue
                        )
                    {
                        boolIsAntecesor = true;
                    }
                }
            }
        }

        return boolIsAntecesor;
    }

    subOpenAvailabilityDisabledModal(strInputId_I,strDeltaType_I = "NA")
    {
        //First, set id and attribute reference of the item to update.
        $("#ipt-itemToUpdate").val( strInputId_I);
        $("#ipt-itemToUpdate").attr("deltaupdate", strDeltaType_I);
        $("#modalBackorderGrant").modal('toggle');
    }

    boolExistAvailability(strInputId_I,intQuantity_I)
    {
        //change
        //var boolExistAvailability = true;
        var boolExistAvailability = false;
        //Get "a" selector and get text value
        var availabilityText = $("#a-" + strInputId_I).text();
        if(!isNaN(availabilityText)){
            var intAvailability = parseInt(availabilityText);
            if(intQuantity_I <= intAvailability){
                boolExistAvailability = true;
            }
        }
        return boolExistAvailability;
    }

    updateItemFromCart(strInputId_I,intQuantity_I,inputSelector_I)
    {
        var cartItem = this.resolveItemCartObject(strInputId_I);
        if(this.state.userIsB2C)
        {
            if(cartItem !=null){
                $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Actualizando carrito, por favor espere...' });
                var boolExistAvailability = this.boolExistAvailability(strInputId_I,intQuantity_I);
                if(boolExistAvailability){
                    client.Carts.editCart({
                        userID: this.props.user.ID,
                        cartID: cartItem.CartId,
                        itemID: cartItem.ItemDetail.ID,
                        quantity: parseInt(intQuantity_I)
                    },
                    function(err, cartUpdateResponse){
                        $.unblockUI();
                        if(err != null){
                            toastr.error("Error al actualizar el artículo del carrito, inténtelo más tarde.");
                        }
                        else{
                            inputSelector_I.val(parseInt(intQuantity_I));
                            context.updateCartProperty(strInputId_I, parseInt(intQuantity_I));
                            context.updateCartSummaryTable(strInputId_I);
                            context.setTotals();
                        }
                    });
                }else{
                    toastr.error("No hay existencias suficientes para este artículo.");
                }
            }else{
                toastr.error("Sucedió un error al actualizar el artículo en el carrito, inténtelo más tarde");
            }
        }else
        {
            if(cartItem != null){
                //Block UI to avoid multiples calls to this method.
                $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Actualizando carrito, por favor espere...' });

                //Quantity always will override the current quantity stored in cart.
                client.Carts.editCart({
                    userID: this.props.user.ID,
                    cartID: cartItem.CartId,
                    itemID: cartItem.ItemDetail.ID,
                    quantity: parseInt(intQuantity_I)
                },
                function(err, cartUpdateResponse){
                    //Unlock the view, and update UI and state context.
                    $.unblockUI();

                    if(err != null){
                        toastr.error("Error al actualizar el artículo del carrito, inténtelo más tarde.");
                    }
                    else{
                        //inputSelector_I.prop( "disabled", false );
                        inputSelector_I.val(parseInt(intQuantity_I));
                        //inputSelector_I.prop( "disabled", true );
                        context.updateCartProperty(strInputId_I, parseInt(intQuantity_I));
                        context.updateCartSummaryTable(strInputId_I);
                        context.setTotals();
                    }
                });
            }
            else{
                toastr.error("Sucedió un error al actualizar el artículo en el carrito, inténtelo más tarde");
            }
        }
    }

    boolIsNumericInput(
        strInput_I
    )
    {
        var boolIsValidInput = true;
        /*var regExpr = /[0-9]|\./;*/
        if (strInput_I == '' || isNaN(strInput_I)/*regExpr.test(strInput_I)*/) {
            boolIsValidInput = false;
        }

        return boolIsValidInput;
    }

    itemOnChangeListener(strInputId_I,)
    {
        var input = $("#ipt-" + strInputId_I);
        var generalAvalableItem,auxiliarAvalableItem;
        if (!this.boolIsNumericInput(input.val()))
        {
            //If input values is not valid input, set original quantity to it.
            var cartItemQty = this.resolveItemCartObject(strInputId_I).CartQty;
            input.val(cartItemQty);
        }
        else {
            var intInputValue = parseInt(input.val());
            let salesUnit = this.getUnidadVenta(strInputId_I);
            if (intInputValue == 0) {
                intInputValue = salesUnit;
            }
            else if (intInputValue > 0) {
                if (this.boolIsMultiple(input.val(), salesUnit)) {
                    intInputValue = intInputValue;
                } else {
                    if (intInputValue < salesUnit) {
                        intInputValue = salesUnit;
                    } else {
                        // Arrays que contendran los valores multiples de salesUnit
                        let multiples_salesUnit = [];
                        var aux = input.val() * salesUnit;

                        for (var i = 1; i <= aux; i++) {
                            if (this.boolIsMultiple(i, salesUnit)) {
                                multiples_salesUnit.push(i);
                            };

                            for (let index = 0; index < multiples_salesUnit.length; index++) {
                                const element = multiples_salesUnit[index];
                                if (input.val() < element) {
                                    intInputValue = element;
                                    break;
                                }
                            }
                        }
                    }
                }
            }
            if(this.state.userIsB2C){
                generalAvalableItem = this.getUnidadVenta(strInputId_I);
            }
            var boolItemsAvailable = this.boolExistAvailability(strInputId_I, intInputValue);
            if(this.state.userIsB2C && boolItemsAvailable){
                input.val(intInputValue);
            }else{
                input.val(intInputValue);
                this.updateItemFromCart(strInputId_I, intInputValue, input);
            }
            let boolIsAntecesor = this.boolIsAntecesor(strInputId_I);
            if (parseInt(intInputValue) > 0)
            {
                if (this.boolAvailabilityCheckDisabled || boolItemsAvailable) {
                    if(this.state.userIsB2C)
                    {
                        if(boolItemsAvailable){
                            this.updateItemFromCart(strInputId_I, parseInt(intInputValue), input);
                        }else{
                            intInputValue = generalAvalableItem;
                            input.val(intInputValue);
                            this.updateItemFromCart(strInputId_I, parseInt(intInputValue), input);
                        }
                    }else{
                        this.updateItemFromCart(strInputId_I, parseInt(intInputValue), input);
                    }
                    }else if (!boolIsAntecesor) {
                        if(this.state.userIsB2C && !boolItemsAvailable){
                            intInputValue = generalAvalableItem;
                            input.val(intInputValue);
                            this.updateItemFromCart(strInputId_I, parseInt(intInputValue), input);
                        }
                        this.subOpenAvailabilityDisabledModal(strInputId_I);
                    }
            }else {
                    this.showDeleteItemModalConfimation(strInputId_I);
            }
        }

    }

/*     initAvailabilityInfoB2C(partNumber, itemDetail, cartItemQty){
        var arrPartCodes = this.arrNumberParts();
        const requestBody = {
            "operatingUnitId": 446,
            "partsCode": arrPartCodes
        };

        //console.log("partCodes");
        client.Availability.GetAvalability(requestBody).then((response) => {
            let totalAvailability = 0;

            var promiseCreateTableLog = new Promise((resolve, reject) => {
                var optionsLog = {
                    pluginId: process.env.NOTIFICACIONES,
                    tableName: 'Logs',
                    request: {
                        "mensaje": "Availability: " + response
                    }
                };

                client.CustomTables.createCustomTableRow(optionsLog, function (err, result) {
                    resolve(result);
                });
            });

            promiseCreateTableLog.then(ctCreate => {

            }, error => {

            });'
            '

            if(response != null && response.Result == 0){
                if(response.Parts != null && response.Parts.length > 0){
                    context.setState({"arrAvailabilityParts":response.Parts});
                    this.state.arrAvailabilityParts.forEach((availabilityPart) => {
                        if (availabilityPart.PartCode === partNumber) {
                            availabilityPart.Availabilitys.forEach((availability) => {
                                totalAvailability += availability.Availability;
                                $("#a-" + itemDetail).text(totalAvailability);
                            });
                        }
                    });
                }
            }
            var packageItem={"itemDetail":itemDetail,"cartItemQty":cartItemQty,"totalAvailability":totalAvailability};
            var arrAvailabilitiesforItemItem= this.state.arrAvailabilitiesforItem.find(item => item.itemDetail == itemDetail);
            if(arrAvailabilitiesforItemItem==null){
                this.setState({arrAvailabilitiesforItem: [...this.state.arrAvailabilitiesforItem, packageItem]});
            }

            return totalAvailability;
        });
    } */


    // Refactored function
initAvailabilityInfoB2C(partNumber, itemDetail, cartItemQty) {
    if(typeof window !== 'undefined'){
        //console.log("Attempting to fetch availability for:", partNumber, itemDetail, cartItemQty);

        // Prevent unnecessary repeated calls for the same item
        if (this.state.lastFetched && this.state.lastFetched[partNumber] === itemDetail) {
            //console.log("Skipping fetch as the availability for this item has already been fetched.");
            return;
        }

        const arrPartCodes = this.arrNumberParts();
        const requestBody = {
            "operatingUnitId": 446,
            "partsCode": arrPartCodes
        };

        client.Availability.GetAvalability(requestBody).then(response => {
            // console.log("Received response for GetAvalability:", response);
            let totalAvailability = 0;

            if (response && response.Result === 0 && response.Parts) {
                response.Parts.forEach(availabilityPart => {
                    if (availabilityPart.PartCode === partNumber) {
                        // console.log("Avalabilityes:",availabilityPart);
                        availabilityPart.Availabilitys.forEach(availability => {

                            totalAvailability += availability.Availability;
                        });
                        
                    }
                });

                // console.log("Updated totalAvailability for partNumber:", partNumber, "Total Availability:", totalAvailability);

                // Update the UI with the new availability
                if(document.getElementById("a-" + itemDetail)) {
                    document.getElementById("a-" + itemDetail).innerText = totalAvailability;
                }
                
                this.setState(prevState => {
                // Correctly update the nested availabilityData state
                const updatedAvailabilityData = {
                    ...prevState.availabilityData,
                    [partNumber]: {
                    totalAvailability,
                    Availabilitys: response.Parts.find(part => part.PartCode === partNumber)?.Availabilitys || []
                    }
                };

                return { availabilityData: updatedAvailabilityData };
                });
                
                // Update the item's availability in state
                this.setState(prevState => {
                    const existingItem = prevState.arrAvailabilitiesforItem.find(item => item.itemDetail === itemDetail);
                    const updatedAvailabilitiesforItem = existingItem
                        ? prevState.arrAvailabilitiesforItem.map(item =>
                            item.itemDetail === itemDetail ? { ...item, totalAvailability } : item)
                        : [...prevState.arrAvailabilitiesforItem, {
                            itemDetail,
                            cartItemQty,
                            totalAvailability
                        }];

                    // Update last fetched to prevent redundant calls
                    const updatedLastFetched = { ...prevState.lastFetched, [partNumber]: itemDetail };

                    return {
                        arrAvailabilitiesforItem: updatedAvailabilitiesforItem,
                        lastFetched: updatedLastFetched
                    };
                });
            } else {
                console.error("Error or unexpected result in GetAvalability response:", response);
            }
        }).catch(error => {
            console.error("Error in GetAvalability request:", error);
        });
    }
}


    showDeleteItemModalConfimation(
        strInputId_I
    )
    {
        //First, set id reference of the item to delete in modal.
        $("#ipt-itemToDelete").val(strInputId_I);
        $("#modalRemoveFromCart").modal('toggle');
    }

    showDeleteItemModalConfimationUnit(
        strInputId_I,
        )
    {
        //First, set id reference of the item to delete in modal.
        $("#ipt-itemToDelete").val(strInputId_I);
        $('#modalRemoveFromCartUnit').modal('show');
        //$("#modalRemoveFromCartUnit").modal('toggle');
    }

    resolveItemCartObject(
        strItemId_I
    )
    {
        return this.state.cartObject.find(cartItem => cartItem.ItemDetail.ID == strItemId_I);
    }

    deleteItemFromCart() {
        //Block UI to avoid multiples calls to this method.
        $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: 'Eliminando artículo del carrito, por favor espere...' });

       // $("#modalRemoveFromCart").modal('toggle');
        $('#modalRemoveFromCartUnit').modal('hide');
        $('#modalRemoveFromCart').modal('hide');

        var itemToDelete = $("#ipt-itemToDelete").val();
        client.Carts.deleteCartItem({
            userId: this.props.user.ID,
            cartId: this.resolveItemCartObject(itemToDelete).CartId
        },
        function(err, cartDeleteResponse){
            //Unlock the view
            $.unblockUI();

            //Delete row from table.
            if(err != null){
                toastr.error("Error eliminando artículo del carrito, inténtelo más tarde.");
            }
            else{
                context.removeItemReferences(itemToDelete);
            }
        });
    }

    generateSlug(itemName) {
        return itemName.replace(/[^a-zA-Z0-9\-]/g, "");
    }

    populateCartPreview() {
        let arr = this.state.cartObject;
        arr = arr.slice(0,3);
        const formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
        });
        $(".h-cart-menu .h-cart-mid > ul .cart-item").remove();
        if (arr.length > 0) {
            arr.map(cart =>  {
                let item = cart.ItemDetail;
                let subtotal = item.Price * cart.CartQty;

                //ARC10053  the discountamount should not be round off to have the correct value.
                let roundOffSubTotal = Math.round(subtotal * 100) / 100;

                //let assume that prices are on MXN
                let strCurrencyCode = "MXN";
                $(".h-cart-menu .h-cart-mid > ul").append(`
                    <li class="cart-item" key=${item.ID}>
                        <div class="item-img">
                            <img alt="" data-src=${item.Media ? item.Media[0].MediaUrl : null} class="lazyload" />
                        </div>
                        <div class="item-info">
                            <p><a href="/items/${context.generateSlug(item.Name)}/${item.ID}">${item.Name}<a/></p>
                            <div class="item-price">
                              <span class="currency">${strCurrencyCode} $ </span> 
                              <span class="value">${formatter.format(roundOffSubTotal)}</span>
                           </div>
                        </div>
                    </li>`
                )
            });
        }
    }

    updateCartPreview()
    {
        let cartItemLength = this.state.cartObject.length;
        if (
            cartItemLength == 0
            )
        {
            $(".h-cart-menu .h-cart-mid > ul .cart-item").remove();
        }
        else
        {
            cartItemLength = 0;
            for (let index = 0; index < this.state.cartObject.length; index++) {
                const cartItem = this.state.cartObject[index];
                cartItemLength += cartItem.CartQty;
            }

            this.populateCartPreview();
        }
        $("#latest-cart-count").text(cartItemLength);
    }

    deleteAllItemsFromCart(
        boolStartProcess_I,
        intNextIndex_I
    )
    {
        if (
            boolStartProcess_I
            )
        {
            $('#emptyingCartMessage').text('Vaciando carrito...');
            $.blockUI({ css: { backgroundColor: '#D1D2D4'}, message: $('#emptyingCartMessage')});
        }
        else
        {
            //Update progress
            $('#emptyingCartMessage').text(`Vaciando carrito (${(intNextIndex_I + 1)}/${this.state.cartObject.length})...`);
        }

        let strCartId = this.state.cartObject[intNextIndex_I].CartId;
        //Delete item from cart.                                            //Esta borrando el el item del carrito en Arcadier.
        client.Carts.deleteCartItem({
            userId: this.props.user.ID,
            cartId: strCartId
        },
        function(err, cartDeleteResponse){
            if (
                (intNextIndex_I + 1) == context.state.cartObject.length
                )
            {
                //Unlock the view
                $.unblockUI();
                $('#emptyingCartMessage').empty();
                context.setState({cartObject:[]});
                context.setState({"isEmpty":""});
                context.setState({"isNotEmpty":"hide"});
                context.updateCartPreview();
            }
            else
            {
                context.deleteAllItemsFromCart(false, intNextIndex_I + 1);
            }
        });
    }

    removeItemReferences(
        strItemId_I
    )
    {
        //Remove item from View.
        $("#tr-" + strItemId_I).remove();

        //Remove from state.
        var auxState = [];
        this.state.cartObject.forEach(function(cartItem, index){
            if(cartItem.ItemDetail.ID != strItemId_I){
                auxState.push(cartItem);
            }
        });

        this.setState({"cartObject":auxState});

        //Check if cartObject is now empty, if does, then, clear all the view.
        if (
            this.state.cartObject.length > 0
        )
        {
            this.totalOrderCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 0);
            this.setState({"numTotalOrder":this.totalOrderCalculated});
            this.totalItemPriceCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 1);
            this.setState({"numItemPriceTotal":this.totalItemPriceCalculated});
            this.totalItemCorePriceCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 2);
            this.setState({"numItemCoreTotal":this.totalItemCorePriceCalculated});
            //                                                              //Recalculate total quantities.
            //console.log("removeItemReferences llego y calcula:::", this.intGetTotalQuantity());
            //console.log("this.state :::", this.state);
            this.setState({"intTotalQuantities":this.intGetTotalQuantity()});
            this.setState({"getTotalWeight":this.getTotalWeight()});
        }
        else
        {
            this.setState({"isEmpty":""});
            this.setState({"isNotEmpty":"hide"});
        }

        this.updateCartPreview();
        toastr.success("El artículo fue eliminado del carrito con éxito!");
        window.location.reload();
    }

    updateCartProperty(
        strElementId_I,
        intQty_I
    )
    {
        var auxCartState = this.state.cartObject;
        // Update Object Cart item.
        this.state.cartObject.forEach(function(cartItem, index){
            if (
                cartItem.ItemDetail.ID == strElementId_I
                )
            {
                auxCartState[index].CartQty = intQty_I;
            }
        });

        // Update cartObject state for futher use.
        this.setState({"cartObject" : auxCartState}, () => {
            context.updateCartPreview();
        });

        // Update also the props in order to update the table rendered.
        this.props.cartPageModel.cartList.forEach(function(cartModel, i){
            cartModel.forEach(function(cart, j){
                if (
                    cart.ItemDetail.ID == strElementId_I
                    )
                {
                    cart.Quantity = intQty_I;
                }
            });
        });

        // Recalculate totals
        this.totalOrderCalculated = this.numRecalculateTotalFromCartObject(auxCartState, 0);
        this.setState({"numTotalOrder":this.totalOrderCalculated});
        this.totalItemPriceCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 1);
        this.setState({"numItemPriceTotal":this.totalItemPriceCalculated});
        this.totalItemCorePriceCalculated = this.numRecalculateTotalFromCartObject(this.state.cartObject, 2);
        this.setState({"numItemCoreTotal":this.totalItemCorePriceCalculated});
    }

    updateCartSummaryTable(
        strElementId_I
    )
    {
        var cartItem = this.state.cartObject.find(cart => cart.ItemDetail.ID == strElementId_I);
        var subTotal = 0.0;
        if(cartItem != null){
            //To easy code.
            var item = cartItem.ItemDetail;
            var itemPriceDefault = item.Price;
            var corePriceCF = item.CustomFields.find(cf => cf.Name == "Precio Core");
            var corePrice = 0.0;
            if(corePriceCF != null){
                if(corePriceCF.Values[0].length > 0){
                    corePrice = parseFloat(corePriceCF.Values[0]);
                }
            }
            let currencyCodeCf = item.CustomFields.find(x => x.Name == "Currency");
            let strCurrencyCode = "";
            if (currencyCodeCf != undefined || currencyCodeCf != null) {
                if(currencyCodeCf.Values[0].length > 0){
                    strCurrencyCode = currencyCodeCf.Values[0];
                }
            }
            //At first all in MXN
            if (
                strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                self.state.currentCurrency == "MXN" && (cartItem.ItemDetail.boolPriceChanged == undefined || cartItem.ItemDetail.boolPriceChanged == false)
                )
            {
                itemPriceDefault = itemPriceDefault * parseFloat(self.state.currentExchange);
            }

            if (
                strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                self.state.currentCurrency == "MXN"
                )
            {
                corePrice = corePrice * parseFloat(self.state.currentExchange);
            }

            subTotal = this.numCalculateSubTotal(cartItem.CartQty, itemPriceDefault, corePrice);
        }

        if(subTotal > 0.0){
            $('#spn-' + strElementId_I).text(this.subFormatMoney(subTotal));
        }
    }

    subFormatMoney(
        numAmount_I,
        intDecimalCount = 2,
        strDecimal = ".",
        strThousands = ","
        )
    {
        try {
            intDecimalCount = Math.abs(intDecimalCount);
            intDecimalCount = isNaN(intDecimalCount) ? 2 : intDecimalCount;

            const negativeSign = numAmount_I < 0 ? "-" : "";

            let str_Z = parseInt(numAmount_I = Math.abs(Number(numAmount_I) || 0).toFixed(intDecimalCount)).toString();
            let str_Z2 = (str_Z.length > 3) ? str_Z.length % 3 : 0;

            return  negativeSign + (str_Z2 ? str_Z.substr(0, str_Z2) + strThousands : '') +
            str_Z.substr(str_Z2).replace(/(\d{3})(?=\d)/g, "$1" +
            strThousands) + (intDecimalCount ? strDecimal +
            Math.abs(numAmount_I - str_Z).toFixed(intDecimalCount).slice(2) : "");
        } catch (e) {
            //console.log(e)
        }
    }

    numCalculateSubTotal(
        intQty_I,
        numBasePrice_I,
        numBaseCorePrice_I
    )
    {
        return intQty_I * (numBasePrice_I + numBaseCorePrice_I);
    }

    numCalculateWithCurrency(
        strCurrencyChangedBy_I
    )
    {
        var numNewTotalWithCurrency = 0.0;
        var numCurrentExchange = parseFloat(this.state.currentExchange);
        var boolshouldIBackAgain = false;
        switch (strCurrencyChangedBy_I) {
            case "USD":
                if(numCurrentExchange > 0){
                    let numItemPriceTotal = this.state.numItemPriceTotal / numCurrentExchange;
                    let numItemCoreTotal = this.state.numItemCoreTotal / numCurrentExchange;
                    this.setState({"numItemPriceTotal":numItemPriceTotal});
                    this.setState({"numItemCoreTotal":numItemCoreTotal});
                }
                else{
                    // Probably if this.state.currentExchange is not updated (-1.0) try again after 1 second
                    // because once loaded the exchange Currency it will change his state
                    boolshouldIBackAgain = true;
                }
                break;
            case "MXN":
                if(numCurrentExchange > 0){
                    //In order to avoid missed decimals set calculated values.
                    //this.setTotals();
                    this.setState({"numItemPriceTotal":this.totalItemPriceCalculated});
                    this.setState({"numItemCoreTotal":this.totalItemCorePriceCalculated});
                }
                else{
                    // Probably if this.state.currentExchange is not updated (-1.0) try again after 1 second
                    // because once loaded the exchange Currency it will change his state
                    boolshouldIBackAgain = true;
                }
                break;
            default:
                break;
        }

        if(boolshouldIBackAgain){
            setTimeout(() => {
                this.numCalculateWithCurrency(strCurrencyChangedBy_I);
            }, 1000);
        }
    }

    renderCartItem() {
        let self = this;
        let tableContent = null;
        let items = [];
        let intTotalItems = 0;

        if(typeof window !== 'undefined'){
            if(self.props.user.CustomFields) {		
                if(document.getElementById('address-lideriduser')) {	
                    if(self.props.user.CustomFields.find(x => x.Name == "Cliente ID")) {	
                        var idlider = self.props.user.CustomFields.find(x => x.Name == "Cliente ID").Values[0];
                        console.log(idlider);
                        document.getElementById('address-lideriduser').value = idlider;
                        document.getElementById('address-lideriduser').setAttribute('address-idlider', idlider);
                    }
                }
            }
        }

        if (this.props.cartPageModel.cartList && this.props.cartPageModel.cartList.length > 0 && this.props.cartPageModel.isArranged === true) {
            this.props.cartPageModel.cartList.forEach(function(merchantItems, parentIndex){
                merchantItems.forEach(function(cartItem, index){
                    var item = cartItem.ItemDetail;
                    var itemPriceDefault = item.Price;
                    //Get Core Price
                    var corePriceCF = null;
                    if(item.CustomFields != null){
                        corePriceCF = item.CustomFields.find(cf => cf.Name == "Precio Core");
                    }

                    var corePrice = 0.0;
                    if(corePriceCF != null){
                        if(corePriceCF.Values[0].length > 0){
                            corePrice = parseFloat(corePriceCF.Values[0]);
                        }
                    }

                    //Get Number Part CF
                    var numberPartCF = null;
                    if(item.CustomFields != null){
                        numberPartCF = item.CustomFields.find(cf => cf.Name == "Número de Parte");
                    }

                    var numberPart = "Na";
                    if(numberPartCF != null){
                        if(numberPartCF.Values[0].length > 0){
                            numberPart = numberPartCF.Values[0];
                        }
                    }
                    var strCurrencyCode = "";
                    var currencyCodeCf = null;
                    if(item.CustomFields != null){
                        currencyCodeCf = item.CustomFields.find(x => x.Name == "Currency");
                        if (currencyCodeCf != undefined || currencyCodeCf != null) {
                            if(currencyCodeCf.Values[0].length > 0){
                                strCurrencyCode = currencyCodeCf.Values[0];
                            }
                        }
                    }

                    //All prices in MXN at first
                    if (
                        strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                        self.state.currentCurrency == "MXN" && (item.boolPriceChanged == undefined || item.boolPriceChanged == false)
                        )
                    {
                        itemPriceDefault = itemPriceDefault * parseFloat(self.state.currentExchange);
                    }

                    //For core price convert price in MXN currency
                    if (
                        strCurrencyCode == "USD" && self.state != null && self.state.currentExchange > 0 &&
                        self.state.currentCurrency == "MXN"
                        )
                    {
                        corePrice = corePrice * parseFloat(self.state.currentExchange);
                    }

                    //Calculate subTotal
                    var subTotal = self.numCalculateSubTotal(cartItem.Quantity, itemPriceDefault, corePrice);

                    intTotalItems = intTotalItems + cartItem.Quantity;
                    if(typeof window !== 'undefined'){
                        if(self.state.userIsB2C){
                            document.querySelectorAll('.bp-table a').forEach(element => {
                                element.style.cursor = 'default';
                            });
                        }else{
                            var itemtotal = "-"
                        }
                    }
                    //check if item is an offer or not
                    var orderType = self.boolIsItemOffer(item) ? "Oferta" : "Programado";
                    items.push(
                        <tr id={"tr-" + item.ID} key={"tr-" + item.ID}>
                            <td><img alt="" src={item.Media[0].MediaUrl} className='checkout-image'/></td>
                            <td><p>{numberPart}</p></td>
                            <td><p>{item.Name}</p></td>
                            <td style={{display: 'none'}}><p>{item.Weight} {item.WeightUnit}</p></td>
                            <td>
                                <div className="bp-quantity-controls">
                                    <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item.ID, "minus")}>-</div>
                                    <div><input type="number" id={"ipt-" + item.ID} defaultValue={cartItem.Quantity} onBlur={() => self.itemOnChangeListener(item.ID)}></input></div>
                                    <div className="bp-quantity-control-box" onClick={() => self.updateItemQuantity(item.ID, "plus")}>+</div>
                                </div>
                            </td>
                            <td><a id={"a-" + item.ID} className="item-available" partcode={numberPart} onClick={() => self.openAvailabilityModal(item.ID)}>{self.initAvailabilityInfoB2C(numberPart,item.ID,cartItem.Quantity)}</a></td>
                            <td style={
                                //In case to roll back delete style
                                {display: 'none'}}><span id={"ordt-" + item.ID}>{orderType}</span></td>
                            <td><span>$</span><span>{self.subFormatMoney(itemPriceDefault)}</span></td>
                            <td><span>$</span><span>{self.subFormatMoney(corePrice)}</span></td>
                            <td style={
                                //In case to roll back delete style
                                {display: 'none'}}><span>$</span><span id={"spn-" + item.ID}>{self.subFormatMoney(subTotal)}</span></td>
                            <td><img alt="" onClick={() => self.showDeleteItemModalConfimation(item.ID)} src="/assets/images/bepensa/trashbin.svg"></img></td>
                        </tr>
                    );
                });
            });

            //Push last line within the calculated totals
            items.push(
                <tr key={"tr-last"}>
                    <td><strong>Subtotal</strong></td>
                    <td><p style={{opacity:0}}>DummyText</p></td>
                    <td><p style={{opacity:0}}>DummyText</p></td>
                    <td>
                        <div className="bp-quantity-controls">
                            {this.state.intTotalQuantities}
                        </div>
                    </td>
                    <td><a style={{opacity:0}}>0</a></td>
                    <td style={
                        //In case to roll back delete style
                        {display: 'none'}}><span id={"ordt-last"}>-</span></td>
                    <td><span>$</span><span>{self.subFormatMoney(
                                self.state != null && self.state.numItemPriceTotal != null ? self.state.numItemPriceTotal : 0.0
                                )}</span></td>
                    <td><span>$</span><span>{self.subFormatMoney(
                                self.state != null && self.state.numItemCoreTotal != null ? self.state.numItemCoreTotal : 0.0
                                ) }</span></td>
                    <td style={
                        //In case to roll back delete style
                        {display: 'none'}}><span>$</span><span id={"spn-last"}>0</span></td>
                    <td><img alt="" style={{opacity:0}} src="/assets/images/bepensa/trashbin.svg"></img></td>
                </tr>
            );

            tableContent = (
                <div className="bp-cart-box full-width">
                    <div className="bp-cb-content  parent-r-b">
                        <div className="table-responsive">
                            <div className="bp-table">
                                <table>
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Número de Parte</th>
                                            <th>Descripción</th>
                                            <th>Cantidad</th>
                                            <th>Existencias</th>
                                            <th style={
                                                //In case to roll back delete style
                                                {display: 'none'}}>Tipo de pedido</th>
                                            <th>Precio unitario</th>
                                            <th>Precio CORE</th>
                                            <th style={
                                                //In case to roll back delete style
                                                {display: 'none'}}>Total</th>
                                            <th style={
                                                //Setting this opacity in order to do not resize the column size
                                                {opacity:0}
                                                }>Remover</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            );
            return tableContent;
        } else {
            return "";
        }
    }

    renderTotals1(){
        return(
            <div className="footer-total">
                <div>
                    <strong>Total de artículos:</strong>&nbsp;<label>{this.state.intTotalQuantities}</label>
                </div>
                <div>
                    <strong>Total orden:</strong>&nbsp;<label><span>$</span>{this.subFormatMoney(this.state.numItemPriceTotal)}</label>
                </div>
            </div>
        );
    }

    renderTotals() {
        return (
            <div className="col-md-12">
                <table className="cost-table" id="summary-order-cart-table">
                    <tbody>
                        <tr>
                            <th></th>
                        </tr>
                        <tr>
                            <td>Total de artículos:</td>
                            <td>
                                <span className="item-price">
                                    <span> {this.state.intTotalQuantities}</span>
                                </span>
                            </td>

                        </tr>

                        <tr>
                            <td>Total orden:</td>

                                <td>
                                    <span className="item-price">$
                                        <span className="priceAmount"> {this.subFormatMoney(this.state.numItemPriceTotal)}</span>
                                    </span>
                                </td>
                        </tr>

                    </tbody>
                </table>
            </div>

        );
    }

    renderShipmentMethods() {
        const self = this;
        const userDetail = self.props.user;
        var tipoCliente = 'B2B';
        if(userDetail) {
            if(userDetail.CustomFields) {
                if(userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario")) {
                    tipoCliente  = userDetail.CustomFields.find(x => x.Name == "Tipo de Usuario").Values[0];
                }
            } else {
                tipoCliente = 'B2C';
            }
        } else {
            tipoCliente = 'B2C';
        }

        var guest = 'block';
        if(this.props.user.Guest) {
            guest = 'none';
        }
        
        return (
            <div>
                <div style={{display: guest}}>
                    <div className="row footer-method">
                        <div className="col-6">
                            <label>Tipo de pedido</label>
                            {tipoCliente === "B2C" ? (
                                <label className='black-color'>Pedido por internet</label>
                            ) : (
                                <select id="select-order-type">
                                    <option value="PROGRAMADO">Programado</option>
                                    <option value="EMERGENCIA">Emergencia</option>
                                    <option value="ENGINE DOWN">Engine Down</option>
                                </select>
                            )}
                        </div>
                        <div className="col-6" id="shipping -method-field">
                            <label>Método de envío</label>
                            <select id="shipping-methods">
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row footer-method no-padding">
                    <div className="col-6">
                            <label className={this.state.boolHideShippingDiv ? "hide":""}>Enviar a</label>
                                <select id="shipping-addresses"
                                    onChange={(e) => this.handleAddressChange(e)}
                                    className={this.state.boolHideShippingDiv ? "hide":"bp-select-read-only"}>
                            </select>
                    </div>
                    <div className="col-6" id="ocurre-div" style={{display: 'none'}}>
                        <label>Seleccione Fletera "Ocurre"</label>
                        <select id="select-occur-addresses">
                        </select>
                        <input id="input-occur-addres" type="text" placeholder="Introduce sucursal de entrega" disabled={this.state.boolOccurLocationNotAvailable}></input>
                    </div>
                </div>
                
                {
                    this.isThisUserB2C() ? (
                        <div className="row footer-method no-padding">                    
                            <div id="sucursal-div" style={{display: 'none', width: '100%'}}>
                                <label>Sucursal donde recoger:</label>
                                <label id="branchName" className='black-color'>Nombre de sucursal</label>
                                <label id="branchAddress" className='black-color'>Dirección de sucursal</label>
                                <div id="branchMap"style={{width: '100%'}}>
                                    <iframe width="100%" height="450" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=450&amp;hl=es&amp;q=19.170069,-96.2343172+(Mi%20nombre%20de%20egocios)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.gps.ie/car-satnav-gps/">Car GPS</a></iframe>
                                </div>                        
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </div>
        );
    }

    subCurrencyCallbackHandler(
        strCurrencyChangedBy_I
    )
    {
		context.setState({"currentCurrency":strCurrencyChangedBy_I});
        context.numCalculateWithCurrency(strCurrencyChangedBy_I);
    }

    subGetAddressCallbackInformation(
        addressObject_I
    )
    {
        //console.log(addressObject_I);
    }

    updateBoolProp(boolValue1, boolValue2) {
        if(!boolValue1 && !boolValue2) {
            context.setState({"boolShowNextStepButton" : true});
            context.setState({"boolShowPayButton" : false});
            context.setState({"boolIsVisibleCurrencyHandler" : false});

            //Update step state
            context.setState({"currentStep":3});

            //Update step UI
            stepperHandler.subNextStep(3);
        } else if(boolValue1 && !boolValue2) {
            context.setState({"boolShowNextStepButton" : true});
            context.setState({"boolShowPayButton" : false});
            context.setState({"boolIsVisibleCurrencyHandler" : false});
            //Update step state
            context.setState({"currentStep":3});

            //Update step UI
            stepperHandler.subNextStep(3);
        } else if(!boolValue1 && boolValue2) {
            context.setState({"boolShowNextStepButton" : true});
            context.setState({"boolShowPayButton" : false});
            context.setState({"boolIsVisibleCurrencyHandler" : false});
            //Update step state
            context.setState({"currentStep":3});

            //Update step UI
            stepperHandler.subNextStep(3);
        } else if(boolValue1 && boolValue2){
            context.setState({"boolShowNextStepButton" : true});
            //Update step state
            context.setState({"currentStep":2});

            //Update step UI
            stepperHandler.subNextStep(2);
        }
    }

    subGetPaymentCallbackInformation(
        paymentObject_I
    )
    {
        //console.log(paymentObject_I);
    }

    numExchangeCurrencyCallback(
        strExchangeCurrency_I
    )
    {

    }

    subGetClickPaymentCallbackInformation(
        eventclick
    )
    {
        //console.log(eventclick);
    }

    stepChanged(
        intStep_I
    )
    {
        var boolHide = false;
        switch (intStep_I) {
            case 1:
                $('#step1').addClass('hide');
                $('#step2').removeClass('hide');

                context.setState({"boolShowContinueButton" : true});
                context.setState({"boolShowNextStepButton" : true});
                context.setState({"boolShowPayButton" : false});
                context.setState({"boolIsVisibleCurrencyHandler" : false});

                boolHide = true;
                break;
            case 2:
                $('#step1').addClass('hide');
                $('#step2').removeClass('hide');

                context.setState({"boolShowContinueButton" : false});
    		    context.setState({"boolShowNextStepButton" : true});
    		    context.setState({"boolShowPayButton" : false});
		    	context.setState({"boolIsVisibleCurrencyHandler" : false});
                break;
            case 3:
                $('#step2').addClass('hide');
                $('#step3').removeClass('hide');

                context.setState({"boolShowContinueButton" : false});
                context.setState({"boolShowNextStepButton" : false});
                context.setState({"boolShowPayButton" : true});
                context.setState({"boolIsVisibleCurrencyHandler" : true});

                //Revert to the desired currency here when reach this step taken from ChangeCurrency component global object.
                if(context.state.changeCurrencyHandler.currencyObject != undefined){
                    let currency = context.state.changeCurrencyHandler.currencyObject.strGetSelectedCurrency();
                    context.subCurrencyCallbackHandler(currency);
                }
                break;
            default:
                break;
        }

        //Update back button hidden state
        context.setState({"hideBackButton":boolHide});

        //Update step state
        context.setState({"currentStep":intStep_I});

        //Update step UI
        stepperHandler.subNextStep(intStep_I);
    }

    backStep()
    {
        var currentStep = this.state.currentStep;
        currentStep--;
        var boolHide = false;
        switch (currentStep) {
            case 1:
                //Update back button hidden state
                $('#step2').addClass('hide');
                $('#step1').removeClass('hide');

                context.setState({"boolShowContinueButton" : true});
                context.setState({"boolShowNextStepButton" : true});
                context.setState({"boolShowPayButton" : false});
                context.setState({"boolIsVisibleCurrencyHandler" : false});

                boolHide = true;

                //Revert to MXN currency here when go back to this step.
                if(context.state.currentCurrency != "MXN"){
                    context.subCurrencyCallbackHandler("MXN");
                }
                break;
            case 2:
                $('#step3').addClass('hide');
                $('#step2').removeClass('hide');

                context.setState({"boolShowContinueButton" : false});
    			context.setState({"boolShowNextStepButton" : true});
	    		context.setState({"boolShowPayButton" : false});
		    	context.setState({"boolIsVisibleCurrencyHandler" : false});

                //Revert to MXN currency here when go back to this step.
                if(context.state.currentCurrency != "MXN"){
                    context.subCurrencyCallbackHandler("MXN");
                }
                break;

            default:
                break;
        }

        //Update back button
        context.setState({"hideBackButton":boolHide});

        //Update step state
        context.setState({"currentStep":currentStep});

        //Update step UI
		stepperHandler.subBackToStep(currentStep)
    }

    getMerchantPaymentTerms(merchantId) {
        if (this.props.cartPageModel && this.props.cartPageModel.merchantPaymentTerms) {
            const { merchantPaymentTerms } = this.props.cartPageModel;
            if (merchantPaymentTerms && merchantPaymentTerms.length > 0) {
                const merchantInfo = merchantPaymentTerms.find(p => p.merchantID == merchantId);
                if (merchantInfo && typeof merchantInfo !== 'undefined' && merchantInfo.paymentTerms && merchantInfo.paymentTerms.length > 0) {
                    const { paymentTerms } = merchantInfo;
                    const defaultPaymentTerm = paymentTerms.find(p => p.Default == true);
                    if (defaultPaymentTerm) {
                        return `${defaultPaymentTerm.Name} - ${defaultPaymentTerm.Description}`;
                    }
                }
            }
        }
        return '';
    }

    renderEditPopup() {
        let self = this;
        let cartItem = {};
        if (this.props.cartPageModel.cartList && this.props.cartPageModel.cartList.length > 0 && this.props.cartPageModel.isArranged === true) {
            this.props.cartPageModel.cartList.forEach(function (merchantsId) {
                merchantsId.forEach(function (cart) {
                    if (cart.ID === self.props.cartPageModel.cartItemToEdit) {
                        cartItem = cart;
                    }
                });
            });

            if ($.isEmptyObject(cartItem) === false) {
                let el = [];
                let elChild = [];
                let StockLimited = cartItem.variantModel.quantityModel.StockLimited;
                let maxQuantity = StockLimited ? cartItem.variantModel.quantityModel.StockQuantity : 0;
                let minQuantity = cartItem.variantModel.quantityModel.MOQ || 0;
                if (minQuantity < 1) {
                    if (cartItem.ItemDetail.CustomFields) {
                        const moqCustoms = cartItem.ItemDetail.CustomFields.filter(r => r.Code.includes('moq'));
                        if (moqCustoms && moqCustoms.length > 0) {
                            const moqCustom = moqCustoms[0];
                            minQuantity = moqCustom.Values[0] * 1;
                        }
                    }
                }
                let selectedQuantity = cartItem.variantModel.quantityModel.Quantity;
                let subTotal = cartItem.variantModel.quantityModel.SubTotal;
                let discountAmount = cartItem.variantModel.quantityModel.DiscountAmount || 0;

                if (cartItem.variantModel && cartItem.variantModel.variantDataList) {
                    let variantGroups = [];
                    let variantCombo = [];

                    //ALL VARIANTS
                    cartItem.variantModel.variantDataList.forEach(function (child) {
                        child.Variants.forEach(function (variant) {
                            if (variantGroups.length !== 0) {
                                variantGroups.map(function (vg, i) {
                                    if (vg.ID === variant.GroupID) {
                                        variantGroups.splice($.inArray(vg, variantGroups), 1);
                                    }
                                });
                            }

                            if (variantCombo.length !== 0) {
                                variantCombo.map(function (vc, i) {
                                    if (vc.ID === variant.ID && vc.GroupID === variant.GroupID) {
                                        variantCombo.splice($.inArray(vc, variantCombo), 1);
                                    }
                                });
                            }

                            variantCombo.push({
                                Group: variant.GroupName,
                                GroupID: variant.GroupID,
                                Name: variant.Name,
                                ID: variant.ID,
                                ItemID: child.ID
                            });

                            variantGroups.push({
                                GroupName: variant.GroupName,
                                ID: variant.GroupID
                            });
                        });

                    });

                    variantGroups.forEach(function (group, ind) {
                        let selectedVariant = {};
                        if (cartItem.variantModel.variantsSelected) {
                            cartItem.variantModel.variantsSelected.forEach(function (variant) {
                                if (variant.GroupID === group.ID) {
                                    selectedVariant = variant;
                                }
                            });
                        }
                        let variantNameList = [];
                        let elVariantChild = [];

                        variantCombo.forEach(function (varcom, i) {
                            if (varcom.GroupID === group.ID) {
                                if (variantNameList.length !== 0) {
                                    variantNameList.map(function (vn, i) {
                                        if (vn.ID === varcom.ID) {
                                            variantNameList.splice($.inArray(vn, variantNameList), 1);
                                        }
                                    });
                                }

                                variantNameList.push({
                                    Name: varcom.Name,
                                    ID: varcom.ID
                                });
                            }
                        });
                        if (variantNameList) {
                            variantNameList.forEach(function (vnl,i) {
                                elVariantChild.push(
                                    <option key={vnl.ID} value={vnl.ID}>{vnl.Name}</option>
                                )
                            });
                        }

                        elChild.push(
                            <span className="title" key={group.ID}>
                                <span>{group.GroupName}:</span>
                                <span className="select-option">
                                    <select  className="required" key={group.ID} value={selectedVariant.ID} onChange={(e) => self.props.TempoChangeVariant(cartItem.ID, group.ID, e.target.value)}>
                                        {elVariantChild}
                                    </select>
                                    <i className="fa fa-angle-down" />
                                </span>
                            </span>
                        )
                    });
                }

                let currencyCodeCf = cartItem.ItemDetail.CustomFields.find(x => x.Name == "Currency");
                let strCurrencyCode = "";
                if (currencyCodeCf != undefined || currencyCodeCf != null) {
                    if(currencyCodeCf.Values[0].length > 0){
                        strCurrencyCode = currencyCodeCf.Values[0];
                    }
                }

                el.push(<div id="cartItemEdit" className="modal fade in" key="carteditz" role="dialog">
                    <div className="modal-dialog cart-edit-item">
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal">×</button>
                                <h4 className="modal-title">{cartItem.ItemDetail.Name}</h4>
                            </div>
                            <div className="modal-body">
                                <div className="item-field">
                                    {elChild}
                                    <span key="quant" className="title">
                                        <span>Quantity:</span>
                                        <input maxquantity={maxQuantity} minquantity={minQuantity} className="numbersOnly required" type="text" value={selectedQuantity} onChange={(e) => self.onUpdateQuantity(cartItem.ID, e.target.value, maxQuantity, minQuantity)} id="quantityVal" />
                                    </span>
                                    <span className="title">
                                        <span>Price Per Item:</span>
                                        <span>{self.renderFormatMoney(strCurrencyCode, cartItem.variantModel.quantityModel.Price)}</span>
                                    </span>
                                    <span className="title">
                                        <span>Subtotal:</span>
                                        <span>
                                            <div className="item-price" id="totalPrice">
                                                {self.renderFormatMoney(strCurrencyCode, subTotal - discountAmount)}
                                            </div>
                                        </span>
                                    </span>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <div className="btn-gray" data-dismiss="modal">Cancel</div>
                                <div className="btn-blue" data-dismiss="modal" onClick={(e) => self.onUpdateCartBtnClick(cartItem.ID, maxQuantity, minQuantity)}>Save</div>
                            </div>
                        </div>
                    </div>
                </div>
                );
                return el;
            }
        }
    }

    validateQuantityField(quantity, maxQuantity, minQuantity) {
        this.validateFields();
        if ($("#cartItemEdit #quantityVal").hasClass('error-con')) {
            $("#cartItemEdit .btn-blue").attr('data-dismiss', '');
            return { error: true, message: 'Quantity field is empty.' };
        }

        if (parseInt(maxQuantity) !== 0) {
            if (parseInt(quantity) > parseInt(maxQuantity)) {
                $("#quantityVal").addClass('error-con');
                $("#cartItemEdit .btn-blue").attr('data-dismiss', '');
                return { error: true, message: 'Item has insufficient stock.'}
            }
        }

        if (parseInt(minQuantity) !== 0) {
            if (parseInt(quantity) < parseInt(minQuantity)) {
                $("#quantityVal").addClass('error-con');
                $("#cartItemEdit .btn-blue").attr('data-dismiss', '');
                return { error: true, message: 'Required minimum order quantity not reached.'};
            }
        }
        $("#cartItemEdit .btn-blue").attr('data-dismiss', 'modal');
        return { error: false };
    }

    onUpdateQuantity(cartItemID, quantity, maxQuantity, minQuantity) {
        this.validateQuantityField(quantity, maxQuantity, minQuantity);
        this.props.TempoChangeQuantity(cartItemID, quantity);
    }

    onUpdateCartBtnClick(cartItemID, maxQuantity, minQuantity) {
        const quantity = $("#quantityVal").val();
        const result = this.validateQuantityField(quantity, maxQuantity, minQuantity);
        if (!result.error) {
            this.props.SaveSelectedVariant(cartItemID, quantity, this.props.user.ID);
        } else {
            toastr.error(result.message);
        }
    }

    renderDeletePopup() {
        return (
            <div id="modalRemoveFromCart" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog delete-modal-content">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p className="text-center">¿Estás seguro de eliminar este artículo de tu carrito?</p>
                        </div>
                        <div className="modal-footer">
                            <input type="hidden" id="ipt-itemToDelete" defaultValue=""></input>
                            <div className="btn-gray btndeletepopup" data-dismiss="modal">Cancelar</div>
                            <div className="btn-green" id="btnRemoveItem">Eliminar del carrito</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderDeletePopupUnit() {
        return (
            <div id="modalRemoveFromCartUnit" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog delete-modal-content">
                    <div className="modal-content">
                        <div className="modal-body">
                             <p className="text-center">Por la configuración de unidad de venta del producto no es posible disminuir la cantidad. ¿Estás seguro de continuar?</p>
                        </div>
                        <div className="modal-footer">
                            <input type="hidden" id="ipt-itemToDelete" defaultValue=""></input>
                            <div className="btn-gray btndeletepopup" data-dismiss="modal">Cancelar</div>
                            <div className="btn-green" id="btnRemoveItemUnit">Eliminar del carrito</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAllowBackOrdersModal(){
        if(this.state.userIsB2C){

        }else{
            return (
                <div id="modalBackorderGrant" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                    <div className="modal-dialog delete-modal-content">
                        <div className="modal-content">
                            <div className="modal-body">
                                <p className="text-center">Al agregar un artículo sin existencias estarás causando que parte de tu pedido quede en backorder, ¿Deseas continuar?</p>
                            </div>
                            <div className="modal-footer">
                                <input type="hidden" id="ipt-itemToUpdate" deltaupdate="" defaultValue=""></input>
                                <div className="btn-gray btndeletepopup" id="btn-cancel-backorder" data-dismiss="modal">Cancelar</div>
                                <div className="btn-green" id="btnAllowBackOrder">Continuar</div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
    }

    renderWarningPopup() {
        return (
            <div id="modalWarning" className="modal fade" role="dialog" data-backdrop="static" data-keyboard="false">
                <div className="modal-dialog delete-modal-content">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p className="text-center">Error al eliminar artículo del carrito, inténtelo más tarde.</p>
                        </div>
                        <div className="modal-footer">
                            <input type="hidden" id="ipt-itemToDelete" defaultValue=""></input>
                            <div className="btn-gray btndeletepopup" data-dismiss="modal">Está bien</div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderAvailabilityModalPopUp() {
        return (
            <div className="modal fade" id="modal-availability" tabIndex="-1" role="dialog" aria-labelledby="userEditorLabel" aria-hidden="true" style={{ display: "none" }}>
                <div className="modal-dialog" style={{ maxWidth: 800 + 'px' }} role="document">
                    <div className="modal-content" style={{borderRadius: 25+ 'px'}}>
                        <div className="modal-header" style={{ marginLeft: 15 + 'px', marginBottom: -10 + 'px' , borderBottom: 'none'}} >
                            <h5 className="modal-title col-md-11" id="userEditorLabel" style={{ fontWeight: "bold" , fontSize: 23+'px'}} >{this.state.strSelectedPartCode}</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>

                        <div className="modal-body" id="modalBody" style={{ marginBottom: 25 + 'px', marginLeft: 25 + 'px', marginRight: 25 + 'px' }}>
                            <table className="table">
                                <thead>
                                    <tr style={{ background: "white", borderColor: '#f0f0f0', borderTopStyle:"solid" }}>
                                        <th scope="col">Sucursal</th>
                                        <th scope="col">Existencias</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <th scope="row">Cargando</th>
                                        <td>-</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

    render() {
        
        return (
            <React.Fragment>
                <AvailabilityContext.Provider value={this.state.availabilityData}>
                <div className="header mod" id="header-section">
                    <HeaderLayout
                        categories={this.props.categories}
                        user={this.props.user}
                        ControlFlags={this.props.controlFlags}
                        numExchangeCurrencyCallback={this.numExchangeCurrencyCallback}/>
                </div>
                <div className="main" id="main-container-cart">
                    <div className="cart-container">
                        <div className="bp-container">
                            <div>
                                <input type="hidden" id="pivoteBranchNombre" name="pivoteBranchNombre" value=""></input>
                                <input type="hidden" id="pivoteBranchDireccion" name="pivoteBranchDireccion" value=""></input>
                                <input type="hidden" id="pivoteBranchLatitud" name="pivoteBranchLatitud" value=""></input>
                                <input type="hidden" id="pivoteBranchLongitud" name="pivoteBranchLongitud" value=""></input>
                                <input type="hidden" id="pogenerado" name="custId" value=""></input>
                                <input type="hidden" id="poenlider" name="custId" value=""></input>
                                <input type="hidden" id="sucFin" name="sucFin" value=""></input>
                                <div id="msj-cart-empty" className={"cart-empty " + this.state.isEmpty}>
                                    <div className="cart-top-sec-left2">
                                        <img className="cart-empty-image" src="/assets/images/cart_icon.svg" alt="cart-empty" /></div>
                                    <div className="cart-top-sec-right2">
                                        <p className="seems-cart-empty-txt">¡Parece que tu carrito está vacío!</p>
                                        <p className="start-search-add-txt">¡Empiece a buscar y agregar!</p>
                                    </div>
                                </div>
                                <div className={"cart-empty-continue " + this.state.isEmpty}>
                                    <div className="cart-empty-continue-btn">
                                        <a href="/">Seguir Comprando</a>
                                    </div>
                                </div>
                            </div>
                            <div id="steper-containter" className={"idc-left " + this.state.isNotEmpty}>
                                <StepperFlow />
                            </div>
                            <img
                                onClick={() => { this.backStep() }}
                                className={this.state.hideBackButton ? 'hide':'bp-back-icon'}
                                id="img-back"
                                src="/assets/images/bepensa/backIcon.png"
                                alt=""></img>
                            <div id="step1" className={"idc-left " + this.state.isNotEmpty}>
                                <div id="div-destroy-cart" className="bp-grid-cart" onClick={() => { this.deleteAllItemsFromCart(true, 0) }}>
                                    <div className="destroy-cart-label">
                                        <label>Vaciar carrito</label>
                                    </div>
                                    <div className='destroy-cart-img'>
                                        <img
                                            style={{width:25, height:25}}
                                            src="/assets/images/bepensa/trashbin.svg"
                                            alt=""></img>
                                    </div>
                                </div>
                                {this.renderCartItem()}
                                {/*this.renderTotals()*/}
                                {this.renderShipmentMethods()}

                            </div>
                            <div id="step2" className="idc-left padding-top hide">
                                <AddressInformation
                                    cartPageModel={this.props.cartPageModel}
                                    user={this.props.user}
                                    callbackAddressInformation={this.subGetAddressCallbackInformation}
                                    updateBoolProp = {this.updateBoolProp}
                                    selectedAddressWidget={this.state.strCookieAddressId}
                                    arrAddresses={this.state.arrAddresses}/>
                            </div>
                            <div id="step3" className="idc-left padding-top hide">
                                <PaymentInformation
                                    cartPageModel={this.props.cartPageModel}
                                    user={this.props.user}
                                    paymentCallback={this.subGetPaymentCallbackInformation}
                                    currentCurrency={this.state.currentCurrency} />
                            </div>
                            <div id="container-summary-order"className={"idc-right bp-no-margin " + this.state.isNotEmpty}>
                                
                                 <OrderSummary
                                    cartPageModel={this.props.cartPageModel}
                                    checkoutPressedCallback={this.checkoutPressedCallback}
                                    CheckoutButtonPressed={this.props.CheckoutButtonPressed}
                                    validateCarts={this.props.validateCarts}
                                    user={this.props.user}
                                    processing={this.props.processing}
                                    setProcessing={this.props.setProcessing}
                                    controlFlags={this.props.controlFlags}
                                    getItemDetails={this.props.getItemDetails}
                                    intCurrentStep={this.state.currentStep}
                                    nextStepHandler={this.stepChanged}
                                    boolShowNextStepButton = {this.state.boolShowNextStepButton}
                                    boolShowContinueButton = {this.state.boolShowContinueButton}
                                    boolShowPayButton = {this.state.boolShowPayButton}
                                    boolIsVisibleCurrencyHandler = {this.state.boolIsVisibleCurrencyHandler}
                                    currencyCallback={this.subCurrencyCallbackHandler}
                                    numBaseIVA={this.state.numBaseIVA}
                                    cuponDiscount={this.state.cuponDiscount}
                                    cuponUseEnabled={this.state.cuponUseEnabled}
                                    numCalculateTotalWithIVA={this.numCalculateTotalWithIVA}
                                    couponfeature={this.couponfeature}
                                    couponfeaturedisable={this.couponfeaturedisable}
                                    intTotalQuantity={this.state.intTotalQuantities}
                                    getTotalWeight={this.state.getTotalWeight}
                                    shippingDataCalculation={this.state.shippingDataCalculation}
                                    shippingRates={this.state.shippingRates}
                                    numTotalOrder={this.state.numTotalOrder}
                                    numItemPriceTotal={this.state.numItemPriceTotal}
                                    numItemCoreTotal={this.state.numItemCoreTotal}
                                    subFormatMoney={this.subFormatMoney}
                                    numCalculateIVA={this.numCalculateIVA}
                                    numCalculateSingleIVA={this.numCalculateSingleIVA}
                                    currentCurrency={this.state.currentCurrency}
                                    eventclick={this.subGetClickPaymentCallbackInformation}
                                    boolSalePriceWasLoaded={this.state.boolSalePriceWasLoaded}
                                    changeCurrencyHandler={this.state.changeCurrencyHandler}
                                    arrCartObject={this.state.cartObject}
                                    importeMinimoEnvioGratis={this.props.importeMinimoEnvioGratis}
                                    shippingAddress={this.state.shippingAddress}
                                    arrAddresses={this.state.arrAddresses}
                                />
                                    
                            </div>
                            {<div id="carousel-sugeridos" className="">
                                <SuggestedCarousel user = {this.props.user} cartItems = {this.props.cartPageModel.cartList} currentAddress = {this.state.strCookieAddressId}></SuggestedCarousel>
                            </div>}
                        </div>
                    </div>
                </div>
                <div className="footer" id="footer-section">
                    <FooterLayout panels={this.props.panels} />
                </div>


                {this.renderDeletePopup()}
                {this.renderDeletePopupUnit()}


                {this.renderAvailabilityModalPopUp()}
                {this.renderAllowBackOrdersModal()}
                <span id="emptyingCartMessage" ></span>
            </AvailabilityContext.Provider>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        cartPageModel: state.cartReducer.cartPageModel,
        user: state.userReducer.user,
        controlFlags: state.marketplaceReducer.ControlFlags,
        locationVariantGroupId: state.marketplaceReducer.locationVariantGroupId,
        processing: state.cartReducer.processing,
        importeMinimoEnvioGratis: state.cartReducer.importeMinimoEnvioGratis
    };
}

function mapCommonDispatchToProps(dispatch) {
    return {
        itemSelect: (obj, merchantID) => dispatch(cartActions.itemSelect(obj, merchantID)),
        editCartItem: (cartID) => dispatch(cartActions.editCartItem(cartID)),
        TempoChangeQuantity: (cartID, quantity) => dispatch(cartActions.TempoChangeQuantity(cartID, quantity)),
        TempoChangeVariant: (cartID, groupName, variantName) => dispatch(cartActions.TempoChangeVariant(cartID, groupName, variantName)),
        SaveSelectedVariant: (cartId,maxQuantity,userId) => dispatch(cartActions.SaveSelectedVariant(cartId,maxQuantity,userId)),
        deleteSelectCartId: (cartID) => dispatch(cartActions.deleteSelectCartId(cartID)),
        deleteCartItem: (cartId, userId) => dispatch(cartActions.deleteCartItem(cartId, userId)),
        arrangeItemCarts: (itemCarts) => dispatch(cartActions.arrangeItemCarts(itemCarts)),
        getUserCarts: (options, callback) => dispatch(cartActions.getUserCarts(options, callback)),
        getItemDetails: (itemId, callback) => dispatch(cartActions.getItemDetails(itemId, callback)),
        setProcessing: (processing) => dispatch({ type: actionTypes.PROCESSING, processing: processing }),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        ...mapCommonDispatchToProps(dispatch),
        ...customMapDispatchToProps(dispatch)
    }
}

const CartPage = ReactRedux.connect(
    mapStateToProps,
    mapDispatchToProps

)(CartPageComponent)

module.exports = {
    CartPage,
    CartPageComponent
}